/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PortalRouteImport } from './routes/portal'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppAuditRouteImport } from './routes/_app/audit'
import { Route as AppCorporateRouteImport } from './routes/_app/corporate'
import { Route as AppDesignRouteImport } from './routes/_app/design'
import { Route as AppEchangesRouteImport } from './routes/_app/echanges'
import { Route as AppMaRecetteRouteImport } from './routes/_app/ma-recette'
import { Route as AppMemoireRouteImport } from './routes/_app/memoire'
import { Route as AppRelancesRouteImport } from './routes/_app/relances'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppTasksRouteImport } from './routes/_app/tasks'
import { Route as AppTeamRouteImport } from './routes/_app/team'
import { Route as AppTimeRouteImport } from './routes/_app/time'
import { Route as ConnexionLienRouteImport } from './routes/connexion.lien'
import { Route as InvitationTokenRouteImport } from './routes/invitation.$token'
import { Route as PSlugRouteImport } from './routes/p.$slug'
import { Route as PortalIndexRouteImport } from './routes/portal/index'
import { Route as PortalAccesRouteImport } from './routes/portal/acces'
import { Route as PortalCompteRouteImport } from './routes/portal/compte'
import { Route as PortalDocumentsRouteImport } from './routes/portal/documents'
import { Route as PortalNotificationsRouteImport } from './routes/portal/notifications'
import { Route as PortalReserverRouteImport } from './routes/portal/reserver'
import { Route as PortalTimeRouteImport } from './routes/portal/time'
import { Route as PortalValidationsRouteImport } from './routes/portal/validations'
import { Route as AppClientsIndexRouteImport } from './routes/_app/clients.index'
import { Route as AppClientsClientIdRouteImport } from './routes/_app/clients.$clientId'
import { Route as AppCorporateIndexRouteImport } from './routes/_app/corporate.index'
import { Route as AppCorporateCalendrierRouteImport } from './routes/_app/corporate.calendrier'
import { Route as AppCorporateExporterRouteImport } from './routes/_app/corporate.exporter'
import { Route as AppCorporateJournalRouteImport } from './routes/_app/corporate.journal'
import { Route as AppCorporatePiecesRouteImport } from './routes/_app/corporate.pieces'
import { Route as AppCorporateRegistresRouteImport } from './routes/_app/corporate.registres'
import { Route as AppEchangesInteractionIdRouteImport } from './routes/_app/echanges.$interactionId'
import { Route as AppFormationsIndexRouteImport } from './routes/_app/formations.index'
import { Route as AppFormationsShortIdRouteImport } from './routes/_app/formations.$shortId'
import { Route as AppFraisIndexRouteImport } from './routes/_app/frais.index'
import { Route as AppFraisExpenseNumberRouteImport } from './routes/_app/frais.$expenseNumber'
import { Route as AppMeetingPollsShortIdRouteImport } from './routes/_app/meeting-polls.$shortId'
import { Route as AppOpportunitiesIndexRouteImport } from './routes/_app/opportunities.index'
import { Route as AppOpportunitiesOpportunityIdRouteImport } from './routes/_app/opportunities.$opportunityId'
import { Route as AppProjectsIndexRouteImport } from './routes/_app/projects.index'
import { Route as AppProjectsProjectRefRouteImport } from './routes/_app/projects.$projectRef'
import { Route as AppProspectingIndexRouteImport } from './routes/_app/prospecting.index'
import { Route as AppQaIndexRouteImport } from './routes/_app/qa.index'
import { Route as AppQaRunIdRouteImport } from './routes/_app/qa.$runId'
import { Route as AppQuestionnairesIndexRouteImport } from './routes/_app/questionnaires.index'
import { Route as AppQuestionnairesShortIdRouteImport } from './routes/_app/questionnaires.$shortId'
import { Route as AppQuotesIndexRouteImport } from './routes/_app/quotes.index'
import { Route as AppQuotesQuoteNumberRouteImport } from './routes/_app/quotes.$quoteNumber'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings.index'
import { Route as AppSettingsApiKeysRouteImport } from './routes/_app/settings.api-keys'
import { Route as AppSettingsBookingRouteImport } from './routes/_app/settings.booking'
import { Route as AppSettingsEmailsRouteImport } from './routes/_app/settings.emails'
import { Route as AppSettingsIntegrationsRouteImport } from './routes/_app/settings.integrations'
import { Route as AppSettingsNotificationsRouteImport } from './routes/_app/settings.notifications'
import { Route as AppSettingsProfileRouteImport } from './routes/_app/settings.profile'
import { Route as AppSettingsQuotesRouteImport } from './routes/_app/settings.quotes'
import { Route as AppSettingsTermsRouteImport } from './routes/_app/settings.terms'
import { Route as AppTasksIndexRouteImport } from './routes/_app/tasks.index'
import { Route as AppTasksTaskKeyRouteImport } from './routes/_app/tasks.$taskKey'
import { Route as AppValidationsShortIdRouteImport } from './routes/_app/validations.$shortId'
import { Route as PortalCompteIndexRouteImport } from './routes/portal/compte.index'
import { Route as PortalCompteNotificationsRouteImport } from './routes/portal/compte.notifications'
import { Route as PortalDocumentsNouveauRouteImport } from './routes/portal/documents_.nouveau'
import { Route as PortalFormationsIndexRouteImport } from './routes/portal/formations.index'
import { Route as PortalFormationsVideoIdRouteImport } from './routes/portal/formations.$videoId'
import { Route as PortalLivrablesDeliverableIdRouteImport } from './routes/portal/livrables.$deliverableId'
import { Route as PortalProjetsIndexRouteImport } from './routes/portal/projets.index'
import { Route as PortalProjetsProjectIdRouteImport } from './routes/portal/projets.$projectId'
import { Route as PortalQuestionnairesIndexRouteImport } from './routes/portal/questionnaires.index'
import { Route as PortalQuestionnairesQuestionnaireIdRouteImport } from './routes/portal/questionnaires.$questionnaireId'
import { Route as PortalRendezVousIndexRouteImport } from './routes/portal/rendez-vous.index'
import { Route as PortalRendezVousPollIdRouteImport } from './routes/portal/rendez-vous.$pollId'
import { Route as PortalRequestsNewRouteImport } from './routes/portal/requests.new'
import { Route as PortalReservationsBookingIdRouteImport } from './routes/portal/reservations.$bookingId'
import { Route as PortalSectionsSectionIdRouteImport } from './routes/portal/sections.$sectionId'
import { Route as PortalSoumissionsIndexRouteImport } from './routes/portal/soumissions.index'
import { Route as PortalSoumissionsQuoteIdRouteImport } from './routes/portal/soumissions.$quoteId'
import { Route as PortalTasksIndexRouteImport } from './routes/portal/tasks.index'
import { Route as PortalTasksTaskKeyRouteImport } from './routes/portal/tasks.$taskKey'
import { Route as AppClientsClientIdIndexRouteImport } from './routes/_app/clients.$clientId.index'
import { Route as AppClientsClientIdAffairesRouteImport } from './routes/_app/clients.$clientId.affaires'
import { Route as AppClientsClientIdContactsRouteImport } from './routes/_app/clients.$clientId.contacts'
import { Route as AppClientsClientIdDocumentsRouteImport } from './routes/_app/clients.$clientId.documents'
import { Route as AppClientsClientIdEchangesRouteImport } from './routes/_app/clients.$clientId.echanges'
import { Route as AppClientsClientIdFacturationRouteImport } from './routes/_app/clients.$clientId.facturation'
import { Route as AppClientsClientIdFormationsRouteImport } from './routes/_app/clients.$clientId.formations'
import { Route as AppClientsClientIdJournalRouteImport } from './routes/_app/clients.$clientId.journal'
import { Route as AppClientsClientIdNotesRouteImport } from './routes/_app/clients.$clientId.notes'
import { Route as AppClientsClientIdProjetsRouteImport } from './routes/_app/clients.$clientId.projets'
import { Route as AppClientsClientIdQuestionnairesRouteImport } from './routes/_app/clients.$clientId.questionnaires'
import { Route as AppClientsClientIdRelancesRouteImport } from './routes/_app/clients.$clientId.relances'
import { Route as AppClientsClientIdRendezVousRouteImport } from './routes/_app/clients.$clientId.rendez-vous'
import { Route as AppClientsClientIdSecretsRouteImport } from './routes/_app/clients.$clientId.secrets'
import { Route as AppClientsClientIdSoumissionsRouteImport } from './routes/_app/clients.$clientId.soumissions'
import { Route as AppClientsClientIdTachesRouteImport } from './routes/_app/clients.$clientId.taches'
import { Route as AppClientsClientIdTempsRouteImport } from './routes/_app/clients.$clientId.temps'
import { Route as AppClientsClientIdTermsRouteImport } from './routes/_app/clients.$clientId.terms'
import { Route as AppCorporateResolutionsIndexRouteImport } from './routes/_app/corporate.resolutions.index'
import { Route as AppCorporateResolutionsMinuteIdRouteImport } from './routes/_app/corporate.resolutions.$minuteId'
import { Route as AppProjectsProjectRefCahierRouteImport } from './routes/_app/projects.$projectRef_.cahier'
import { Route as AppProjectsProjectRefLivrablesRouteImport } from './routes/_app/projects.$projectRef_.livrables'
import { Route as AppProjectsProjectRefRecettesRouteImport } from './routes/_app/projects.$projectRef_.recettes'
import { Route as AppProspectingProgramsProgramIdRouteImport } from './routes/_app/prospecting.programs.$programId'
import { Route as AppProspectingProspectsProspectIdRouteImport } from './routes/_app/prospecting.prospects.$prospectId'
import { Route as AppQaRunIdJouerRouteImport } from './routes/_app/qa.$runId_.jouer'
import { Route as AppQaBugsIndexRouteImport } from './routes/_app/qa.bugs.index'
import { Route as AppQaBugsBugRefRouteImport } from './routes/_app/qa.bugs.$bugRef'
import { Route as AppQaBugsNouveauRouteImport } from './routes/_app/qa.bugs.nouveau'
import { Route as AppSettingsIntegrationsMetaRouteImport } from './routes/_app/settings.integrations_.meta'
import { Route as AppClientsClientIdRendezVousNouvelleRouteImport } from './routes/_app/clients.$clientId.rendez-vous_.nouvelle'
import { Route as AppClientsClientIdDocumentsDocumentIdRouteImport } from './routes/_app/clients.$clientId_.documents.$documentId'
import { Route as AppClientsClientIdDocumentsNewRouteImport } from './routes/_app/clients.$clientId_.documents.new'
import { Route as AppClientsClientIdEchangesInteractionIdRouteImport } from './routes/_app/clients.$clientId_.echanges.$interactionId'
import { Route as AppProjectsProjectRefCahierKeyRouteImport } from './routes/_app/projects.$projectRef_.cahier_.$key'
import { Route as AppProjectsProjectRefControlesKeyRouteImport } from './routes/_app/projects.$projectRef_.controles_.$key'
import { Route as AppProjectsProjectRefLivrablesKeyRouteImport } from './routes/_app/projects.$projectRef_.livrables_.$key'
import { Route as AppProjectsProjectRefRecettesKeyRouteImport } from './routes/_app/projects.$projectRef_.recettes_.$key'
import { Route as AppProjectsProjectRefSprintsSprintIdRouteImport } from './routes/_app/projects.$projectRef_.sprints.$sprintId'
import { Route as PortalProjetsProjectIdCahierIndexRouteImport } from './routes/portal/projets.$projectId_.cahier.index'
import { Route as PortalProjetsProjectIdCahierKeyRouteImport } from './routes/portal/projets.$projectId_.cahier.$key'
import { Route as PortalProjetsProjectIdLivrablesKeyRouteImport } from './routes/portal/projets.$projectId_.livrables.$key'
import { Route as AppProjectsProjectRefLivrablesKeyRecetteRouteImport } from './routes/_app/projects.$projectRef_.livrables_.$key_.recette'
import { Route as PortalProjetsProjectIdLivrablesKeyTesterRouteImport } from './routes/portal/projets.$projectId_.livrables.$key_.tester'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalRoute = PortalRouteImport.update({
  id: '/portal',
  path: '/portal',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAuditRoute = AppAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AppRoute,
} as any)
const AppCorporateRoute = AppCorporateRouteImport.update({
  id: '/corporate',
  path: '/corporate',
  getParentRoute: () => AppRoute,
} as any)
const AppDesignRoute = AppDesignRouteImport.update({
  id: '/design',
  path: '/design',
  getParentRoute: () => AppRoute,
} as any)
const AppEchangesRoute = AppEchangesRouteImport.update({
  id: '/echanges',
  path: '/echanges',
  getParentRoute: () => AppRoute,
} as any)
const AppMaRecetteRoute = AppMaRecetteRouteImport.update({
  id: '/ma-recette',
  path: '/ma-recette',
  getParentRoute: () => AppRoute,
} as any)
const AppMemoireRoute = AppMemoireRouteImport.update({
  id: '/memoire',
  path: '/memoire',
  getParentRoute: () => AppRoute,
} as any)
const AppRelancesRoute = AppRelancesRouteImport.update({
  id: '/relances',
  path: '/relances',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppTasksRoute = AppTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => AppRoute,
} as any)
const AppTeamRoute = AppTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AppRoute,
} as any)
const AppTimeRoute = AppTimeRouteImport.update({
  id: '/time',
  path: '/time',
  getParentRoute: () => AppRoute,
} as any)
const ConnexionLienRoute = ConnexionLienRouteImport.update({
  id: '/connexion/lien',
  path: '/connexion/lien',
  getParentRoute: () => rootRouteImport,
} as any)
const InvitationTokenRoute = InvitationTokenRouteImport.update({
  id: '/invitation/$token',
  path: '/invitation/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const PSlugRoute = PSlugRouteImport.update({
  id: '/p/$slug',
  path: '/p/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalIndexRoute = PortalIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PortalRoute,
} as any)
const PortalAccesRoute = PortalAccesRouteImport.update({
  id: '/acces',
  path: '/acces',
  getParentRoute: () => PortalRoute,
} as any)
const PortalCompteRoute = PortalCompteRouteImport.update({
  id: '/compte',
  path: '/compte',
  getParentRoute: () => PortalRoute,
} as any)
const PortalDocumentsRoute = PortalDocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => PortalRoute,
} as any)
const PortalNotificationsRoute = PortalNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => PortalRoute,
} as any)
const PortalReserverRoute = PortalReserverRouteImport.update({
  id: '/reserver',
  path: '/reserver',
  getParentRoute: () => PortalRoute,
} as any)
const PortalTimeRoute = PortalTimeRouteImport.update({
  id: '/time',
  path: '/time',
  getParentRoute: () => PortalRoute,
} as any)
const PortalValidationsRoute = PortalValidationsRouteImport.update({
  id: '/validations',
  path: '/validations',
  getParentRoute: () => PortalRoute,
} as any)
const AppClientsIndexRoute = AppClientsIndexRouteImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => AppRoute,
} as any)
const AppClientsClientIdRoute = AppClientsClientIdRouteImport.update({
  id: '/clients/$clientId',
  path: '/clients/$clientId',
  getParentRoute: () => AppRoute,
} as any)
const AppCorporateIndexRoute = AppCorporateIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppCorporateRoute,
} as any)
const AppCorporateCalendrierRoute = AppCorporateCalendrierRouteImport.update({
  id: '/calendrier',
  path: '/calendrier',
  getParentRoute: () => AppCorporateRoute,
} as any)
const AppCorporateExporterRoute = AppCorporateExporterRouteImport.update({
  id: '/exporter',
  path: '/exporter',
  getParentRoute: () => AppCorporateRoute,
} as any)
const AppCorporateJournalRoute = AppCorporateJournalRouteImport.update({
  id: '/journal',
  path: '/journal',
  getParentRoute: () => AppCorporateRoute,
} as any)
const AppCorporatePiecesRoute = AppCorporatePiecesRouteImport.update({
  id: '/pieces',
  path: '/pieces',
  getParentRoute: () => AppCorporateRoute,
} as any)
const AppCorporateRegistresRoute = AppCorporateRegistresRouteImport.update({
  id: '/registres',
  path: '/registres',
  getParentRoute: () => AppCorporateRoute,
} as any)
const AppEchangesInteractionIdRoute =
  AppEchangesInteractionIdRouteImport.update({
    id: '/$interactionId',
    path: '/$interactionId',
    getParentRoute: () => AppEchangesRoute,
  } as any)
const AppFormationsIndexRoute = AppFormationsIndexRouteImport.update({
  id: '/formations/',
  path: '/formations/',
  getParentRoute: () => AppRoute,
} as any)
const AppFormationsShortIdRoute = AppFormationsShortIdRouteImport.update({
  id: '/formations/$shortId',
  path: '/formations/$shortId',
  getParentRoute: () => AppRoute,
} as any)
const AppFraisIndexRoute = AppFraisIndexRouteImport.update({
  id: '/frais/',
  path: '/frais/',
  getParentRoute: () => AppRoute,
} as any)
const AppFraisExpenseNumberRoute = AppFraisExpenseNumberRouteImport.update({
  id: '/frais/$expenseNumber',
  path: '/frais/$expenseNumber',
  getParentRoute: () => AppRoute,
} as any)
const AppMeetingPollsShortIdRoute = AppMeetingPollsShortIdRouteImport.update({
  id: '/meeting-polls/$shortId',
  path: '/meeting-polls/$shortId',
  getParentRoute: () => AppRoute,
} as any)
const AppOpportunitiesIndexRoute = AppOpportunitiesIndexRouteImport.update({
  id: '/opportunities/',
  path: '/opportunities/',
  getParentRoute: () => AppRoute,
} as any)
const AppOpportunitiesOpportunityIdRoute =
  AppOpportunitiesOpportunityIdRouteImport.update({
    id: '/opportunities/$opportunityId',
    path: '/opportunities/$opportunityId',
    getParentRoute: () => AppRoute,
  } as any)
const AppProjectsIndexRoute = AppProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsProjectRefRoute = AppProjectsProjectRefRouteImport.update({
  id: '/projects/$projectRef',
  path: '/projects/$projectRef',
  getParentRoute: () => AppRoute,
} as any)
const AppProspectingIndexRoute = AppProspectingIndexRouteImport.update({
  id: '/prospecting/',
  path: '/prospecting/',
  getParentRoute: () => AppRoute,
} as any)
const AppQaIndexRoute = AppQaIndexRouteImport.update({
  id: '/qa/',
  path: '/qa/',
  getParentRoute: () => AppRoute,
} as any)
const AppQaRunIdRoute = AppQaRunIdRouteImport.update({
  id: '/qa/$runId',
  path: '/qa/$runId',
  getParentRoute: () => AppRoute,
} as any)
const AppQuestionnairesIndexRoute = AppQuestionnairesIndexRouteImport.update({
  id: '/questionnaires/',
  path: '/questionnaires/',
  getParentRoute: () => AppRoute,
} as any)
const AppQuestionnairesShortIdRoute =
  AppQuestionnairesShortIdRouteImport.update({
    id: '/questionnaires/$shortId',
    path: '/questionnaires/$shortId',
    getParentRoute: () => AppRoute,
  } as any)
const AppQuotesIndexRoute = AppQuotesIndexRouteImport.update({
  id: '/quotes/',
  path: '/quotes/',
  getParentRoute: () => AppRoute,
} as any)
const AppQuotesQuoteNumberRoute = AppQuotesQuoteNumberRouteImport.update({
  id: '/quotes/$quoteNumber',
  path: '/quotes/$quoteNumber',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsApiKeysRoute = AppSettingsApiKeysRouteImport.update({
  id: '/api-keys',
  path: '/api-keys',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsBookingRoute = AppSettingsBookingRouteImport.update({
  id: '/booking',
  path: '/booking',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsEmailsRoute = AppSettingsEmailsRouteImport.update({
  id: '/emails',
  path: '/emails',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsIntegrationsRoute = AppSettingsIntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsNotificationsRoute =
  AppSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsProfileRoute = AppSettingsProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsQuotesRoute = AppSettingsQuotesRouteImport.update({
  id: '/quotes',
  path: '/quotes',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsTermsRoute = AppSettingsTermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppTasksIndexRoute = AppTasksIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppTasksRoute,
} as any)
const AppTasksTaskKeyRoute = AppTasksTaskKeyRouteImport.update({
  id: '/$taskKey',
  path: '/$taskKey',
  getParentRoute: () => AppTasksRoute,
} as any)
const AppValidationsShortIdRoute = AppValidationsShortIdRouteImport.update({
  id: '/validations/$shortId',
  path: '/validations/$shortId',
  getParentRoute: () => AppRoute,
} as any)
const PortalCompteIndexRoute = PortalCompteIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PortalCompteRoute,
} as any)
const PortalCompteNotificationsRoute =
  PortalCompteNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => PortalCompteRoute,
  } as any)
const PortalDocumentsNouveauRoute = PortalDocumentsNouveauRouteImport.update({
  id: '/documents_/nouveau',
  path: '/documents/nouveau',
  getParentRoute: () => PortalRoute,
} as any)
const PortalFormationsIndexRoute = PortalFormationsIndexRouteImport.update({
  id: '/formations/',
  path: '/formations/',
  getParentRoute: () => PortalRoute,
} as any)
const PortalFormationsVideoIdRoute = PortalFormationsVideoIdRouteImport.update({
  id: '/formations/$videoId',
  path: '/formations/$videoId',
  getParentRoute: () => PortalRoute,
} as any)
const PortalLivrablesDeliverableIdRoute =
  PortalLivrablesDeliverableIdRouteImport.update({
    id: '/livrables/$deliverableId',
    path: '/livrables/$deliverableId',
    getParentRoute: () => PortalRoute,
  } as any)
const PortalProjetsIndexRoute = PortalProjetsIndexRouteImport.update({
  id: '/projets/',
  path: '/projets/',
  getParentRoute: () => PortalRoute,
} as any)
const PortalProjetsProjectIdRoute = PortalProjetsProjectIdRouteImport.update({
  id: '/projets/$projectId',
  path: '/projets/$projectId',
  getParentRoute: () => PortalRoute,
} as any)
const PortalQuestionnairesIndexRoute =
  PortalQuestionnairesIndexRouteImport.update({
    id: '/questionnaires/',
    path: '/questionnaires/',
    getParentRoute: () => PortalRoute,
  } as any)
const PortalQuestionnairesQuestionnaireIdRoute =
  PortalQuestionnairesQuestionnaireIdRouteImport.update({
    id: '/questionnaires/$questionnaireId',
    path: '/questionnaires/$questionnaireId',
    getParentRoute: () => PortalRoute,
  } as any)
const PortalRendezVousIndexRoute = PortalRendezVousIndexRouteImport.update({
  id: '/rendez-vous/',
  path: '/rendez-vous/',
  getParentRoute: () => PortalRoute,
} as any)
const PortalRendezVousPollIdRoute = PortalRendezVousPollIdRouteImport.update({
  id: '/rendez-vous/$pollId',
  path: '/rendez-vous/$pollId',
  getParentRoute: () => PortalRoute,
} as any)
const PortalRequestsNewRoute = PortalRequestsNewRouteImport.update({
  id: '/requests/new',
  path: '/requests/new',
  getParentRoute: () => PortalRoute,
} as any)
const PortalReservationsBookingIdRoute =
  PortalReservationsBookingIdRouteImport.update({
    id: '/reservations/$bookingId',
    path: '/reservations/$bookingId',
    getParentRoute: () => PortalRoute,
  } as any)
const PortalSectionsSectionIdRoute = PortalSectionsSectionIdRouteImport.update({
  id: '/sections/$sectionId',
  path: '/sections/$sectionId',
  getParentRoute: () => PortalRoute,
} as any)
const PortalSoumissionsIndexRoute = PortalSoumissionsIndexRouteImport.update({
  id: '/soumissions/',
  path: '/soumissions/',
  getParentRoute: () => PortalRoute,
} as any)
const PortalSoumissionsQuoteIdRoute =
  PortalSoumissionsQuoteIdRouteImport.update({
    id: '/soumissions/$quoteId',
    path: '/soumissions/$quoteId',
    getParentRoute: () => PortalRoute,
  } as any)
const PortalTasksIndexRoute = PortalTasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => PortalRoute,
} as any)
const PortalTasksTaskKeyRoute = PortalTasksTaskKeyRouteImport.update({
  id: '/tasks/$taskKey',
  path: '/tasks/$taskKey',
  getParentRoute: () => PortalRoute,
} as any)
const AppClientsClientIdIndexRoute = AppClientsClientIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppClientsClientIdRoute,
} as any)
const AppClientsClientIdAffairesRoute =
  AppClientsClientIdAffairesRouteImport.update({
    id: '/affaires',
    path: '/affaires',
    getParentRoute: () => AppClientsClientIdRoute,
  } as any)
const AppClientsClientIdContactsRoute =
  AppClientsClientIdContactsRouteImport.update({
    id: '/contacts',
    path: '/contacts',
    getParentRoute: () => AppClientsClientIdRoute,
  } as any)
const AppClientsClientIdDocumentsRoute =
  AppClientsClientIdDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => AppClientsClientIdRoute,
  } as any)
const AppClientsClientIdEchangesRoute =
  AppClientsClientIdEchangesRouteImport.update({
    id: '/echanges',
    path: '/echanges',
    getParentRoute: () => AppClientsClientIdRoute,
  } as any)
const AppClientsClientIdFacturationRoute =
  AppClientsClientIdFacturationRouteImport.update({
    id: '/facturation',
    path: '/facturation',
    getParentRoute: () => AppClientsClientIdRoute,
  } as any)
const AppClientsClientIdFormationsRoute =
  AppClientsClientIdFormationsRouteImport.update({
    id: '/formations',
    path: '/formations',
    getParentRoute: () => AppClientsClientIdRoute,
  } as any)
const AppClientsClientIdJournalRoute =
  AppClientsClientIdJournalRouteImport.update({
    id: '/journal',
    path: '/journal',
    getParentRoute: () => AppClientsClientIdRoute,
  } as any)
const AppClientsClientIdNotesRoute = AppClientsClientIdNotesRouteImport.update({
  id: '/notes',
  path: '/notes',
  getParentRoute: () => AppClientsClientIdRoute,
} as any)
const AppClientsClientIdProjetsRoute =
  AppClientsClientIdProjetsRouteImport.update({
    id: '/projets',
    path: '/projets',
    getParentRoute: () => AppClientsClientIdRoute,
  } as any)
const AppClientsClientIdQuestionnairesRoute =
  AppClientsClientIdQuestionnairesRouteImport.update({
    id: '/questionnaires',
    path: '/questionnaires',
    getParentRoute: () => AppClientsClientIdRoute,
  } as any)
const AppClientsClientIdRelancesRoute =
  AppClientsClientIdRelancesRouteImport.update({
    id: '/relances',
    path: '/relances',
    getParentRoute: () => AppClientsClientIdRoute,
  } as any)
const AppClientsClientIdRendezVousRoute =
  AppClientsClientIdRendezVousRouteImport.update({
    id: '/rendez-vous',
    path: '/rendez-vous',
    getParentRoute: () => AppClientsClientIdRoute,
  } as any)
const AppClientsClientIdSecretsRoute =
  AppClientsClientIdSecretsRouteImport.update({
    id: '/secrets',
    path: '/secrets',
    getParentRoute: () => AppClientsClientIdRoute,
  } as any)
const AppClientsClientIdSoumissionsRoute =
  AppClientsClientIdSoumissionsRouteImport.update({
    id: '/soumissions',
    path: '/soumissions',
    getParentRoute: () => AppClientsClientIdRoute,
  } as any)
const AppClientsClientIdTachesRoute =
  AppClientsClientIdTachesRouteImport.update({
    id: '/taches',
    path: '/taches',
    getParentRoute: () => AppClientsClientIdRoute,
  } as any)
const AppClientsClientIdTempsRoute = AppClientsClientIdTempsRouteImport.update({
  id: '/temps',
  path: '/temps',
  getParentRoute: () => AppClientsClientIdRoute,
} as any)
const AppClientsClientIdTermsRoute = AppClientsClientIdTermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => AppClientsClientIdRoute,
} as any)
const AppCorporateResolutionsIndexRoute =
  AppCorporateResolutionsIndexRouteImport.update({
    id: '/resolutions/',
    path: '/resolutions/',
    getParentRoute: () => AppCorporateRoute,
  } as any)
const AppCorporateResolutionsMinuteIdRoute =
  AppCorporateResolutionsMinuteIdRouteImport.update({
    id: '/resolutions/$minuteId',
    path: '/resolutions/$minuteId',
    getParentRoute: () => AppCorporateRoute,
  } as any)
const AppProjectsProjectRefCahierRoute =
  AppProjectsProjectRefCahierRouteImport.update({
    id: '/projects/$projectRef_/cahier',
    path: '/projects/$projectRef/cahier',
    getParentRoute: () => AppRoute,
  } as any)
const AppProjectsProjectRefLivrablesRoute =
  AppProjectsProjectRefLivrablesRouteImport.update({
    id: '/projects/$projectRef_/livrables',
    path: '/projects/$projectRef/livrables',
    getParentRoute: () => AppRoute,
  } as any)
const AppProjectsProjectRefRecettesRoute =
  AppProjectsProjectRefRecettesRouteImport.update({
    id: '/projects/$projectRef_/recettes',
    path: '/projects/$projectRef/recettes',
    getParentRoute: () => AppRoute,
  } as any)
const AppProspectingProgramsProgramIdRoute =
  AppProspectingProgramsProgramIdRouteImport.update({
    id: '/prospecting/programs/$programId',
    path: '/prospecting/programs/$programId',
    getParentRoute: () => AppRoute,
  } as any)
const AppProspectingProspectsProspectIdRoute =
  AppProspectingProspectsProspectIdRouteImport.update({
    id: '/prospecting/prospects/$prospectId',
    path: '/prospecting/prospects/$prospectId',
    getParentRoute: () => AppRoute,
  } as any)
const AppQaRunIdJouerRoute = AppQaRunIdJouerRouteImport.update({
  id: '/qa/$runId_/jouer',
  path: '/qa/$runId/jouer',
  getParentRoute: () => AppRoute,
} as any)
const AppQaBugsIndexRoute = AppQaBugsIndexRouteImport.update({
  id: '/qa/bugs/',
  path: '/qa/bugs/',
  getParentRoute: () => AppRoute,
} as any)
const AppQaBugsBugRefRoute = AppQaBugsBugRefRouteImport.update({
  id: '/qa/bugs/$bugRef',
  path: '/qa/bugs/$bugRef',
  getParentRoute: () => AppRoute,
} as any)
const AppQaBugsNouveauRoute = AppQaBugsNouveauRouteImport.update({
  id: '/qa/bugs/nouveau',
  path: '/qa/bugs/nouveau',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsIntegrationsMetaRoute =
  AppSettingsIntegrationsMetaRouteImport.update({
    id: '/integrations_/meta',
    path: '/integrations/meta',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppClientsClientIdRendezVousNouvelleRoute =
  AppClientsClientIdRendezVousNouvelleRouteImport.update({
    id: '/rendez-vous_/nouvelle',
    path: '/rendez-vous/nouvelle',
    getParentRoute: () => AppClientsClientIdRoute,
  } as any)
const AppClientsClientIdDocumentsDocumentIdRoute =
  AppClientsClientIdDocumentsDocumentIdRouteImport.update({
    id: '/clients/$clientId_/documents/$documentId',
    path: '/clients/$clientId/documents/$documentId',
    getParentRoute: () => AppRoute,
  } as any)
const AppClientsClientIdDocumentsNewRoute =
  AppClientsClientIdDocumentsNewRouteImport.update({
    id: '/clients/$clientId_/documents/new',
    path: '/clients/$clientId/documents/new',
    getParentRoute: () => AppRoute,
  } as any)
const AppClientsClientIdEchangesInteractionIdRoute =
  AppClientsClientIdEchangesInteractionIdRouteImport.update({
    id: '/clients/$clientId_/echanges/$interactionId',
    path: '/clients/$clientId/echanges/$interactionId',
    getParentRoute: () => AppRoute,
  } as any)
const AppProjectsProjectRefCahierKeyRoute =
  AppProjectsProjectRefCahierKeyRouteImport.update({
    id: '/projects/$projectRef_/cahier_/$key',
    path: '/projects/$projectRef/cahier/$key',
    getParentRoute: () => AppRoute,
  } as any)
const AppProjectsProjectRefControlesKeyRoute =
  AppProjectsProjectRefControlesKeyRouteImport.update({
    id: '/projects/$projectRef_/controles_/$key',
    path: '/projects/$projectRef/controles/$key',
    getParentRoute: () => AppRoute,
  } as any)
const AppProjectsProjectRefLivrablesKeyRoute =
  AppProjectsProjectRefLivrablesKeyRouteImport.update({
    id: '/projects/$projectRef_/livrables_/$key',
    path: '/projects/$projectRef/livrables/$key',
    getParentRoute: () => AppRoute,
  } as any)
const AppProjectsProjectRefRecettesKeyRoute =
  AppProjectsProjectRefRecettesKeyRouteImport.update({
    id: '/projects/$projectRef_/recettes_/$key',
    path: '/projects/$projectRef/recettes/$key',
    getParentRoute: () => AppRoute,
  } as any)
const AppProjectsProjectRefSprintsSprintIdRoute =
  AppProjectsProjectRefSprintsSprintIdRouteImport.update({
    id: '/projects/$projectRef_/sprints/$sprintId',
    path: '/projects/$projectRef/sprints/$sprintId',
    getParentRoute: () => AppRoute,
  } as any)
const PortalProjetsProjectIdCahierIndexRoute =
  PortalProjetsProjectIdCahierIndexRouteImport.update({
    id: '/projets/$projectId_/cahier/',
    path: '/projets/$projectId/cahier/',
    getParentRoute: () => PortalRoute,
  } as any)
const PortalProjetsProjectIdCahierKeyRoute =
  PortalProjetsProjectIdCahierKeyRouteImport.update({
    id: '/projets/$projectId_/cahier/$key',
    path: '/projets/$projectId/cahier/$key',
    getParentRoute: () => PortalRoute,
  } as any)
const PortalProjetsProjectIdLivrablesKeyRoute =
  PortalProjetsProjectIdLivrablesKeyRouteImport.update({
    id: '/projets/$projectId_/livrables/$key',
    path: '/projets/$projectId/livrables/$key',
    getParentRoute: () => PortalRoute,
  } as any)
const AppProjectsProjectRefLivrablesKeyRecetteRoute =
  AppProjectsProjectRefLivrablesKeyRecetteRouteImport.update({
    id: '/projects/$projectRef_/livrables_/$key_/recette',
    path: '/projects/$projectRef/livrables/$key/recette',
    getParentRoute: () => AppRoute,
  } as any)
const PortalProjetsProjectIdLivrablesKeyTesterRoute =
  PortalProjetsProjectIdLivrablesKeyTesterRouteImport.update({
    id: '/projets/$projectId_/livrables/$key_/tester',
    path: '/projets/$projectId/livrables/$key/tester',
    getParentRoute: () => PortalRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/portal': typeof PortalRouteWithChildren
  '/audit': typeof AppAuditRoute
  '/corporate': typeof AppCorporateRouteWithChildren
  '/design': typeof AppDesignRoute
  '/echanges': typeof AppEchangesRouteWithChildren
  '/ma-recette': typeof AppMaRecetteRoute
  '/memoire': typeof AppMemoireRoute
  '/relances': typeof AppRelancesRoute
  '/settings': typeof AppSettingsRouteWithChildren
  '/tasks': typeof AppTasksRouteWithChildren
  '/team': typeof AppTeamRoute
  '/time': typeof AppTimeRoute
  '/connexion/lien': typeof ConnexionLienRoute
  '/invitation/$token': typeof InvitationTokenRoute
  '/p/$slug': typeof PSlugRoute
  '/portal/acces': typeof PortalAccesRoute
  '/portal/compte': typeof PortalCompteRouteWithChildren
  '/portal/documents': typeof PortalDocumentsRoute
  '/portal/notifications': typeof PortalNotificationsRoute
  '/portal/reserver': typeof PortalReserverRoute
  '/portal/time': typeof PortalTimeRoute
  '/portal/validations': typeof PortalValidationsRoute
  '/portal/': typeof PortalIndexRoute
  '/clients/$clientId': typeof AppClientsClientIdRouteWithChildren
  '/corporate/calendrier': typeof AppCorporateCalendrierRoute
  '/corporate/exporter': typeof AppCorporateExporterRoute
  '/corporate/journal': typeof AppCorporateJournalRoute
  '/corporate/pieces': typeof AppCorporatePiecesRoute
  '/corporate/registres': typeof AppCorporateRegistresRoute
  '/echanges/$interactionId': typeof AppEchangesInteractionIdRoute
  '/formations/$shortId': typeof AppFormationsShortIdRoute
  '/frais/$expenseNumber': typeof AppFraisExpenseNumberRoute
  '/meeting-polls/$shortId': typeof AppMeetingPollsShortIdRoute
  '/opportunities/$opportunityId': typeof AppOpportunitiesOpportunityIdRoute
  '/projects/$projectRef': typeof AppProjectsProjectRefRoute
  '/qa/$runId': typeof AppQaRunIdRoute
  '/questionnaires/$shortId': typeof AppQuestionnairesShortIdRoute
  '/quotes/$quoteNumber': typeof AppQuotesQuoteNumberRoute
  '/settings/api-keys': typeof AppSettingsApiKeysRoute
  '/settings/booking': typeof AppSettingsBookingRoute
  '/settings/emails': typeof AppSettingsEmailsRoute
  '/settings/integrations': typeof AppSettingsIntegrationsRoute
  '/settings/notifications': typeof AppSettingsNotificationsRoute
  '/settings/profile': typeof AppSettingsProfileRoute
  '/settings/quotes': typeof AppSettingsQuotesRoute
  '/settings/terms': typeof AppSettingsTermsRoute
  '/tasks/$taskKey': typeof AppTasksTaskKeyRoute
  '/validations/$shortId': typeof AppValidationsShortIdRoute
  '/portal/compte/notifications': typeof PortalCompteNotificationsRoute
  '/portal/documents/nouveau': typeof PortalDocumentsNouveauRoute
  '/portal/formations/$videoId': typeof PortalFormationsVideoIdRoute
  '/portal/livrables/$deliverableId': typeof PortalLivrablesDeliverableIdRoute
  '/portal/projets/$projectId': typeof PortalProjetsProjectIdRoute
  '/portal/questionnaires/$questionnaireId': typeof PortalQuestionnairesQuestionnaireIdRoute
  '/portal/rendez-vous/$pollId': typeof PortalRendezVousPollIdRoute
  '/portal/requests/new': typeof PortalRequestsNewRoute
  '/portal/reservations/$bookingId': typeof PortalReservationsBookingIdRoute
  '/portal/sections/$sectionId': typeof PortalSectionsSectionIdRoute
  '/portal/soumissions/$quoteId': typeof PortalSoumissionsQuoteIdRoute
  '/portal/tasks/$taskKey': typeof PortalTasksTaskKeyRoute
  '/clients/': typeof AppClientsIndexRoute
  '/corporate/': typeof AppCorporateIndexRoute
  '/formations/': typeof AppFormationsIndexRoute
  '/frais/': typeof AppFraisIndexRoute
  '/opportunities/': typeof AppOpportunitiesIndexRoute
  '/projects/': typeof AppProjectsIndexRoute
  '/prospecting/': typeof AppProspectingIndexRoute
  '/qa/': typeof AppQaIndexRoute
  '/questionnaires/': typeof AppQuestionnairesIndexRoute
  '/quotes/': typeof AppQuotesIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/tasks/': typeof AppTasksIndexRoute
  '/portal/compte/': typeof PortalCompteIndexRoute
  '/portal/formations/': typeof PortalFormationsIndexRoute
  '/portal/projets/': typeof PortalProjetsIndexRoute
  '/portal/questionnaires/': typeof PortalQuestionnairesIndexRoute
  '/portal/rendez-vous/': typeof PortalRendezVousIndexRoute
  '/portal/soumissions/': typeof PortalSoumissionsIndexRoute
  '/portal/tasks/': typeof PortalTasksIndexRoute
  '/clients/$clientId/affaires': typeof AppClientsClientIdAffairesRoute
  '/clients/$clientId/contacts': typeof AppClientsClientIdContactsRoute
  '/clients/$clientId/documents': typeof AppClientsClientIdDocumentsRoute
  '/clients/$clientId/echanges': typeof AppClientsClientIdEchangesRoute
  '/clients/$clientId/facturation': typeof AppClientsClientIdFacturationRoute
  '/clients/$clientId/formations': typeof AppClientsClientIdFormationsRoute
  '/clients/$clientId/journal': typeof AppClientsClientIdJournalRoute
  '/clients/$clientId/notes': typeof AppClientsClientIdNotesRoute
  '/clients/$clientId/projets': typeof AppClientsClientIdProjetsRoute
  '/clients/$clientId/questionnaires': typeof AppClientsClientIdQuestionnairesRoute
  '/clients/$clientId/relances': typeof AppClientsClientIdRelancesRoute
  '/clients/$clientId/rendez-vous': typeof AppClientsClientIdRendezVousRoute
  '/clients/$clientId/secrets': typeof AppClientsClientIdSecretsRoute
  '/clients/$clientId/soumissions': typeof AppClientsClientIdSoumissionsRoute
  '/clients/$clientId/taches': typeof AppClientsClientIdTachesRoute
  '/clients/$clientId/temps': typeof AppClientsClientIdTempsRoute
  '/clients/$clientId/terms': typeof AppClientsClientIdTermsRoute
  '/corporate/resolutions/$minuteId': typeof AppCorporateResolutionsMinuteIdRoute
  '/projects/$projectRef/cahier': typeof AppProjectsProjectRefCahierRoute
  '/projects/$projectRef/livrables': typeof AppProjectsProjectRefLivrablesRoute
  '/projects/$projectRef/recettes': typeof AppProjectsProjectRefRecettesRoute
  '/prospecting/programs/$programId': typeof AppProspectingProgramsProgramIdRoute
  '/prospecting/prospects/$prospectId': typeof AppProspectingProspectsProspectIdRoute
  '/qa/$runId/jouer': typeof AppQaRunIdJouerRoute
  '/qa/bugs/$bugRef': typeof AppQaBugsBugRefRoute
  '/qa/bugs/nouveau': typeof AppQaBugsNouveauRoute
  '/settings/integrations/meta': typeof AppSettingsIntegrationsMetaRoute
  '/clients/$clientId/': typeof AppClientsClientIdIndexRoute
  '/corporate/resolutions/': typeof AppCorporateResolutionsIndexRoute
  '/qa/bugs/': typeof AppQaBugsIndexRoute
  '/clients/$clientId/rendez-vous/nouvelle': typeof AppClientsClientIdRendezVousNouvelleRoute
  '/clients/$clientId/documents/$documentId': typeof AppClientsClientIdDocumentsDocumentIdRoute
  '/clients/$clientId/documents/new': typeof AppClientsClientIdDocumentsNewRoute
  '/clients/$clientId/echanges/$interactionId': typeof AppClientsClientIdEchangesInteractionIdRoute
  '/projects/$projectRef/cahier/$key': typeof AppProjectsProjectRefCahierKeyRoute
  '/projects/$projectRef/controles/$key': typeof AppProjectsProjectRefControlesKeyRoute
  '/projects/$projectRef/livrables/$key': typeof AppProjectsProjectRefLivrablesKeyRoute
  '/projects/$projectRef/recettes/$key': typeof AppProjectsProjectRefRecettesKeyRoute
  '/projects/$projectRef/sprints/$sprintId': typeof AppProjectsProjectRefSprintsSprintIdRoute
  '/portal/projets/$projectId/cahier/$key': typeof PortalProjetsProjectIdCahierKeyRoute
  '/portal/projets/$projectId/livrables/$key': typeof PortalProjetsProjectIdLivrablesKeyRoute
  '/portal/projets/$projectId/cahier/': typeof PortalProjetsProjectIdCahierIndexRoute
  '/projects/$projectRef/livrables/$key/recette': typeof AppProjectsProjectRefLivrablesKeyRecetteRoute
  '/portal/projets/$projectId/livrables/$key/tester': typeof PortalProjetsProjectIdLivrablesKeyTesterRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/audit': typeof AppAuditRoute
  '/design': typeof AppDesignRoute
  '/echanges': typeof AppEchangesRouteWithChildren
  '/ma-recette': typeof AppMaRecetteRoute
  '/memoire': typeof AppMemoireRoute
  '/relances': typeof AppRelancesRoute
  '/team': typeof AppTeamRoute
  '/time': typeof AppTimeRoute
  '/connexion/lien': typeof ConnexionLienRoute
  '/invitation/$token': typeof InvitationTokenRoute
  '/p/$slug': typeof PSlugRoute
  '/portal/acces': typeof PortalAccesRoute
  '/portal/documents': typeof PortalDocumentsRoute
  '/portal/notifications': typeof PortalNotificationsRoute
  '/portal/reserver': typeof PortalReserverRoute
  '/portal/time': typeof PortalTimeRoute
  '/portal/validations': typeof PortalValidationsRoute
  '/': typeof AppIndexRoute
  '/portal': typeof PortalIndexRoute
  '/corporate/calendrier': typeof AppCorporateCalendrierRoute
  '/corporate/exporter': typeof AppCorporateExporterRoute
  '/corporate/journal': typeof AppCorporateJournalRoute
  '/corporate/pieces': typeof AppCorporatePiecesRoute
  '/corporate/registres': typeof AppCorporateRegistresRoute
  '/echanges/$interactionId': typeof AppEchangesInteractionIdRoute
  '/formations/$shortId': typeof AppFormationsShortIdRoute
  '/frais/$expenseNumber': typeof AppFraisExpenseNumberRoute
  '/meeting-polls/$shortId': typeof AppMeetingPollsShortIdRoute
  '/opportunities/$opportunityId': typeof AppOpportunitiesOpportunityIdRoute
  '/projects/$projectRef': typeof AppProjectsProjectRefRoute
  '/qa/$runId': typeof AppQaRunIdRoute
  '/questionnaires/$shortId': typeof AppQuestionnairesShortIdRoute
  '/quotes/$quoteNumber': typeof AppQuotesQuoteNumberRoute
  '/settings/api-keys': typeof AppSettingsApiKeysRoute
  '/settings/booking': typeof AppSettingsBookingRoute
  '/settings/emails': typeof AppSettingsEmailsRoute
  '/settings/integrations': typeof AppSettingsIntegrationsRoute
  '/settings/notifications': typeof AppSettingsNotificationsRoute
  '/settings/profile': typeof AppSettingsProfileRoute
  '/settings/quotes': typeof AppSettingsQuotesRoute
  '/settings/terms': typeof AppSettingsTermsRoute
  '/tasks/$taskKey': typeof AppTasksTaskKeyRoute
  '/validations/$shortId': typeof AppValidationsShortIdRoute
  '/portal/compte/notifications': typeof PortalCompteNotificationsRoute
  '/portal/documents/nouveau': typeof PortalDocumentsNouveauRoute
  '/portal/formations/$videoId': typeof PortalFormationsVideoIdRoute
  '/portal/livrables/$deliverableId': typeof PortalLivrablesDeliverableIdRoute
  '/portal/projets/$projectId': typeof PortalProjetsProjectIdRoute
  '/portal/questionnaires/$questionnaireId': typeof PortalQuestionnairesQuestionnaireIdRoute
  '/portal/rendez-vous/$pollId': typeof PortalRendezVousPollIdRoute
  '/portal/requests/new': typeof PortalRequestsNewRoute
  '/portal/reservations/$bookingId': typeof PortalReservationsBookingIdRoute
  '/portal/sections/$sectionId': typeof PortalSectionsSectionIdRoute
  '/portal/soumissions/$quoteId': typeof PortalSoumissionsQuoteIdRoute
  '/portal/tasks/$taskKey': typeof PortalTasksTaskKeyRoute
  '/clients': typeof AppClientsIndexRoute
  '/corporate': typeof AppCorporateIndexRoute
  '/formations': typeof AppFormationsIndexRoute
  '/frais': typeof AppFraisIndexRoute
  '/opportunities': typeof AppOpportunitiesIndexRoute
  '/projects': typeof AppProjectsIndexRoute
  '/prospecting': typeof AppProspectingIndexRoute
  '/qa': typeof AppQaIndexRoute
  '/questionnaires': typeof AppQuestionnairesIndexRoute
  '/quotes': typeof AppQuotesIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/tasks': typeof AppTasksIndexRoute
  '/portal/compte': typeof PortalCompteIndexRoute
  '/portal/formations': typeof PortalFormationsIndexRoute
  '/portal/projets': typeof PortalProjetsIndexRoute
  '/portal/questionnaires': typeof PortalQuestionnairesIndexRoute
  '/portal/rendez-vous': typeof PortalRendezVousIndexRoute
  '/portal/soumissions': typeof PortalSoumissionsIndexRoute
  '/portal/tasks': typeof PortalTasksIndexRoute
  '/clients/$clientId/affaires': typeof AppClientsClientIdAffairesRoute
  '/clients/$clientId/contacts': typeof AppClientsClientIdContactsRoute
  '/clients/$clientId/documents': typeof AppClientsClientIdDocumentsRoute
  '/clients/$clientId/echanges': typeof AppClientsClientIdEchangesRoute
  '/clients/$clientId/facturation': typeof AppClientsClientIdFacturationRoute
  '/clients/$clientId/formations': typeof AppClientsClientIdFormationsRoute
  '/clients/$clientId/journal': typeof AppClientsClientIdJournalRoute
  '/clients/$clientId/notes': typeof AppClientsClientIdNotesRoute
  '/clients/$clientId/projets': typeof AppClientsClientIdProjetsRoute
  '/clients/$clientId/questionnaires': typeof AppClientsClientIdQuestionnairesRoute
  '/clients/$clientId/relances': typeof AppClientsClientIdRelancesRoute
  '/clients/$clientId/rendez-vous': typeof AppClientsClientIdRendezVousRoute
  '/clients/$clientId/secrets': typeof AppClientsClientIdSecretsRoute
  '/clients/$clientId/soumissions': typeof AppClientsClientIdSoumissionsRoute
  '/clients/$clientId/taches': typeof AppClientsClientIdTachesRoute
  '/clients/$clientId/temps': typeof AppClientsClientIdTempsRoute
  '/clients/$clientId/terms': typeof AppClientsClientIdTermsRoute
  '/corporate/resolutions/$minuteId': typeof AppCorporateResolutionsMinuteIdRoute
  '/projects/$projectRef/cahier': typeof AppProjectsProjectRefCahierRoute
  '/projects/$projectRef/livrables': typeof AppProjectsProjectRefLivrablesRoute
  '/projects/$projectRef/recettes': typeof AppProjectsProjectRefRecettesRoute
  '/prospecting/programs/$programId': typeof AppProspectingProgramsProgramIdRoute
  '/prospecting/prospects/$prospectId': typeof AppProspectingProspectsProspectIdRoute
  '/qa/$runId/jouer': typeof AppQaRunIdJouerRoute
  '/qa/bugs/$bugRef': typeof AppQaBugsBugRefRoute
  '/qa/bugs/nouveau': typeof AppQaBugsNouveauRoute
  '/settings/integrations/meta': typeof AppSettingsIntegrationsMetaRoute
  '/clients/$clientId': typeof AppClientsClientIdIndexRoute
  '/corporate/resolutions': typeof AppCorporateResolutionsIndexRoute
  '/qa/bugs': typeof AppQaBugsIndexRoute
  '/clients/$clientId/rendez-vous/nouvelle': typeof AppClientsClientIdRendezVousNouvelleRoute
  '/clients/$clientId/documents/$documentId': typeof AppClientsClientIdDocumentsDocumentIdRoute
  '/clients/$clientId/documents/new': typeof AppClientsClientIdDocumentsNewRoute
  '/clients/$clientId/echanges/$interactionId': typeof AppClientsClientIdEchangesInteractionIdRoute
  '/projects/$projectRef/cahier/$key': typeof AppProjectsProjectRefCahierKeyRoute
  '/projects/$projectRef/controles/$key': typeof AppProjectsProjectRefControlesKeyRoute
  '/projects/$projectRef/livrables/$key': typeof AppProjectsProjectRefLivrablesKeyRoute
  '/projects/$projectRef/recettes/$key': typeof AppProjectsProjectRefRecettesKeyRoute
  '/projects/$projectRef/sprints/$sprintId': typeof AppProjectsProjectRefSprintsSprintIdRoute
  '/portal/projets/$projectId/cahier/$key': typeof PortalProjetsProjectIdCahierKeyRoute
  '/portal/projets/$projectId/livrables/$key': typeof PortalProjetsProjectIdLivrablesKeyRoute
  '/portal/projets/$projectId/cahier': typeof PortalProjetsProjectIdCahierIndexRoute
  '/projects/$projectRef/livrables/$key/recette': typeof AppProjectsProjectRefLivrablesKeyRecetteRoute
  '/portal/projets/$projectId/livrables/$key/tester': typeof PortalProjetsProjectIdLivrablesKeyTesterRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/portal': typeof PortalRouteWithChildren
  '/_app/audit': typeof AppAuditRoute
  '/_app/corporate': typeof AppCorporateRouteWithChildren
  '/_app/design': typeof AppDesignRoute
  '/_app/echanges': typeof AppEchangesRouteWithChildren
  '/_app/ma-recette': typeof AppMaRecetteRoute
  '/_app/memoire': typeof AppMemoireRoute
  '/_app/relances': typeof AppRelancesRoute
  '/_app/settings': typeof AppSettingsRouteWithChildren
  '/_app/tasks': typeof AppTasksRouteWithChildren
  '/_app/team': typeof AppTeamRoute
  '/_app/time': typeof AppTimeRoute
  '/connexion/lien': typeof ConnexionLienRoute
  '/invitation/$token': typeof InvitationTokenRoute
  '/p/$slug': typeof PSlugRoute
  '/portal/acces': typeof PortalAccesRoute
  '/portal/compte': typeof PortalCompteRouteWithChildren
  '/portal/documents': typeof PortalDocumentsRoute
  '/portal/notifications': typeof PortalNotificationsRoute
  '/portal/reserver': typeof PortalReserverRoute
  '/portal/time': typeof PortalTimeRoute
  '/portal/validations': typeof PortalValidationsRoute
  '/_app/': typeof AppIndexRoute
  '/portal/': typeof PortalIndexRoute
  '/_app/clients/$clientId': typeof AppClientsClientIdRouteWithChildren
  '/_app/corporate/calendrier': typeof AppCorporateCalendrierRoute
  '/_app/corporate/exporter': typeof AppCorporateExporterRoute
  '/_app/corporate/journal': typeof AppCorporateJournalRoute
  '/_app/corporate/pieces': typeof AppCorporatePiecesRoute
  '/_app/corporate/registres': typeof AppCorporateRegistresRoute
  '/_app/echanges/$interactionId': typeof AppEchangesInteractionIdRoute
  '/_app/formations/$shortId': typeof AppFormationsShortIdRoute
  '/_app/frais/$expenseNumber': typeof AppFraisExpenseNumberRoute
  '/_app/meeting-polls/$shortId': typeof AppMeetingPollsShortIdRoute
  '/_app/opportunities/$opportunityId': typeof AppOpportunitiesOpportunityIdRoute
  '/_app/projects/$projectRef': typeof AppProjectsProjectRefRoute
  '/_app/qa/$runId': typeof AppQaRunIdRoute
  '/_app/questionnaires/$shortId': typeof AppQuestionnairesShortIdRoute
  '/_app/quotes/$quoteNumber': typeof AppQuotesQuoteNumberRoute
  '/_app/settings/api-keys': typeof AppSettingsApiKeysRoute
  '/_app/settings/booking': typeof AppSettingsBookingRoute
  '/_app/settings/emails': typeof AppSettingsEmailsRoute
  '/_app/settings/integrations': typeof AppSettingsIntegrationsRoute
  '/_app/settings/notifications': typeof AppSettingsNotificationsRoute
  '/_app/settings/profile': typeof AppSettingsProfileRoute
  '/_app/settings/quotes': typeof AppSettingsQuotesRoute
  '/_app/settings/terms': typeof AppSettingsTermsRoute
  '/_app/tasks/$taskKey': typeof AppTasksTaskKeyRoute
  '/_app/validations/$shortId': typeof AppValidationsShortIdRoute
  '/portal/compte/notifications': typeof PortalCompteNotificationsRoute
  '/portal/documents_/nouveau': typeof PortalDocumentsNouveauRoute
  '/portal/formations/$videoId': typeof PortalFormationsVideoIdRoute
  '/portal/livrables/$deliverableId': typeof PortalLivrablesDeliverableIdRoute
  '/portal/projets/$projectId': typeof PortalProjetsProjectIdRoute
  '/portal/questionnaires/$questionnaireId': typeof PortalQuestionnairesQuestionnaireIdRoute
  '/portal/rendez-vous/$pollId': typeof PortalRendezVousPollIdRoute
  '/portal/requests/new': typeof PortalRequestsNewRoute
  '/portal/reservations/$bookingId': typeof PortalReservationsBookingIdRoute
  '/portal/sections/$sectionId': typeof PortalSectionsSectionIdRoute
  '/portal/soumissions/$quoteId': typeof PortalSoumissionsQuoteIdRoute
  '/portal/tasks/$taskKey': typeof PortalTasksTaskKeyRoute
  '/_app/clients/': typeof AppClientsIndexRoute
  '/_app/corporate/': typeof AppCorporateIndexRoute
  '/_app/formations/': typeof AppFormationsIndexRoute
  '/_app/frais/': typeof AppFraisIndexRoute
  '/_app/opportunities/': typeof AppOpportunitiesIndexRoute
  '/_app/projects/': typeof AppProjectsIndexRoute
  '/_app/prospecting/': typeof AppProspectingIndexRoute
  '/_app/qa/': typeof AppQaIndexRoute
  '/_app/questionnaires/': typeof AppQuestionnairesIndexRoute
  '/_app/quotes/': typeof AppQuotesIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/tasks/': typeof AppTasksIndexRoute
  '/portal/compte/': typeof PortalCompteIndexRoute
  '/portal/formations/': typeof PortalFormationsIndexRoute
  '/portal/projets/': typeof PortalProjetsIndexRoute
  '/portal/questionnaires/': typeof PortalQuestionnairesIndexRoute
  '/portal/rendez-vous/': typeof PortalRendezVousIndexRoute
  '/portal/soumissions/': typeof PortalSoumissionsIndexRoute
  '/portal/tasks/': typeof PortalTasksIndexRoute
  '/_app/clients/$clientId/affaires': typeof AppClientsClientIdAffairesRoute
  '/_app/clients/$clientId/contacts': typeof AppClientsClientIdContactsRoute
  '/_app/clients/$clientId/documents': typeof AppClientsClientIdDocumentsRoute
  '/_app/clients/$clientId/echanges': typeof AppClientsClientIdEchangesRoute
  '/_app/clients/$clientId/facturation': typeof AppClientsClientIdFacturationRoute
  '/_app/clients/$clientId/formations': typeof AppClientsClientIdFormationsRoute
  '/_app/clients/$clientId/journal': typeof AppClientsClientIdJournalRoute
  '/_app/clients/$clientId/notes': typeof AppClientsClientIdNotesRoute
  '/_app/clients/$clientId/projets': typeof AppClientsClientIdProjetsRoute
  '/_app/clients/$clientId/questionnaires': typeof AppClientsClientIdQuestionnairesRoute
  '/_app/clients/$clientId/relances': typeof AppClientsClientIdRelancesRoute
  '/_app/clients/$clientId/rendez-vous': typeof AppClientsClientIdRendezVousRoute
  '/_app/clients/$clientId/secrets': typeof AppClientsClientIdSecretsRoute
  '/_app/clients/$clientId/soumissions': typeof AppClientsClientIdSoumissionsRoute
  '/_app/clients/$clientId/taches': typeof AppClientsClientIdTachesRoute
  '/_app/clients/$clientId/temps': typeof AppClientsClientIdTempsRoute
  '/_app/clients/$clientId/terms': typeof AppClientsClientIdTermsRoute
  '/_app/corporate/resolutions/$minuteId': typeof AppCorporateResolutionsMinuteIdRoute
  '/_app/projects/$projectRef_/cahier': typeof AppProjectsProjectRefCahierRoute
  '/_app/projects/$projectRef_/livrables': typeof AppProjectsProjectRefLivrablesRoute
  '/_app/projects/$projectRef_/recettes': typeof AppProjectsProjectRefRecettesRoute
  '/_app/prospecting/programs/$programId': typeof AppProspectingProgramsProgramIdRoute
  '/_app/prospecting/prospects/$prospectId': typeof AppProspectingProspectsProspectIdRoute
  '/_app/qa/$runId_/jouer': typeof AppQaRunIdJouerRoute
  '/_app/qa/bugs/$bugRef': typeof AppQaBugsBugRefRoute
  '/_app/qa/bugs/nouveau': typeof AppQaBugsNouveauRoute
  '/_app/settings/integrations_/meta': typeof AppSettingsIntegrationsMetaRoute
  '/_app/clients/$clientId/': typeof AppClientsClientIdIndexRoute
  '/_app/corporate/resolutions/': typeof AppCorporateResolutionsIndexRoute
  '/_app/qa/bugs/': typeof AppQaBugsIndexRoute
  '/_app/clients/$clientId/rendez-vous_/nouvelle': typeof AppClientsClientIdRendezVousNouvelleRoute
  '/_app/clients/$clientId_/documents/$documentId': typeof AppClientsClientIdDocumentsDocumentIdRoute
  '/_app/clients/$clientId_/documents/new': typeof AppClientsClientIdDocumentsNewRoute
  '/_app/clients/$clientId_/echanges/$interactionId': typeof AppClientsClientIdEchangesInteractionIdRoute
  '/_app/projects/$projectRef_/cahier_/$key': typeof AppProjectsProjectRefCahierKeyRoute
  '/_app/projects/$projectRef_/controles_/$key': typeof AppProjectsProjectRefControlesKeyRoute
  '/_app/projects/$projectRef_/livrables_/$key': typeof AppProjectsProjectRefLivrablesKeyRoute
  '/_app/projects/$projectRef_/recettes_/$key': typeof AppProjectsProjectRefRecettesKeyRoute
  '/_app/projects/$projectRef_/sprints/$sprintId': typeof AppProjectsProjectRefSprintsSprintIdRoute
  '/portal/projets/$projectId_/cahier/$key': typeof PortalProjetsProjectIdCahierKeyRoute
  '/portal/projets/$projectId_/livrables/$key': typeof PortalProjetsProjectIdLivrablesKeyRoute
  '/portal/projets/$projectId_/cahier/': typeof PortalProjetsProjectIdCahierIndexRoute
  '/_app/projects/$projectRef_/livrables_/$key_/recette': typeof AppProjectsProjectRefLivrablesKeyRecetteRoute
  '/portal/projets/$projectId_/livrables/$key_/tester': typeof PortalProjetsProjectIdLivrablesKeyTesterRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/portal'
    | '/audit'
    | '/corporate'
    | '/design'
    | '/echanges'
    | '/ma-recette'
    | '/memoire'
    | '/relances'
    | '/settings'
    | '/tasks'
    | '/team'
    | '/time'
    | '/connexion/lien'
    | '/invitation/$token'
    | '/p/$slug'
    | '/portal/acces'
    | '/portal/compte'
    | '/portal/documents'
    | '/portal/notifications'
    | '/portal/reserver'
    | '/portal/time'
    | '/portal/validations'
    | '/portal/'
    | '/clients/$clientId'
    | '/corporate/calendrier'
    | '/corporate/exporter'
    | '/corporate/journal'
    | '/corporate/pieces'
    | '/corporate/registres'
    | '/echanges/$interactionId'
    | '/formations/$shortId'
    | '/frais/$expenseNumber'
    | '/meeting-polls/$shortId'
    | '/opportunities/$opportunityId'
    | '/projects/$projectRef'
    | '/qa/$runId'
    | '/questionnaires/$shortId'
    | '/quotes/$quoteNumber'
    | '/settings/api-keys'
    | '/settings/booking'
    | '/settings/emails'
    | '/settings/integrations'
    | '/settings/notifications'
    | '/settings/profile'
    | '/settings/quotes'
    | '/settings/terms'
    | '/tasks/$taskKey'
    | '/validations/$shortId'
    | '/portal/compte/notifications'
    | '/portal/documents/nouveau'
    | '/portal/formations/$videoId'
    | '/portal/livrables/$deliverableId'
    | '/portal/projets/$projectId'
    | '/portal/questionnaires/$questionnaireId'
    | '/portal/rendez-vous/$pollId'
    | '/portal/requests/new'
    | '/portal/reservations/$bookingId'
    | '/portal/sections/$sectionId'
    | '/portal/soumissions/$quoteId'
    | '/portal/tasks/$taskKey'
    | '/clients/'
    | '/corporate/'
    | '/formations/'
    | '/frais/'
    | '/opportunities/'
    | '/projects/'
    | '/prospecting/'
    | '/qa/'
    | '/questionnaires/'
    | '/quotes/'
    | '/settings/'
    | '/tasks/'
    | '/portal/compte/'
    | '/portal/formations/'
    | '/portal/projets/'
    | '/portal/questionnaires/'
    | '/portal/rendez-vous/'
    | '/portal/soumissions/'
    | '/portal/tasks/'
    | '/clients/$clientId/affaires'
    | '/clients/$clientId/contacts'
    | '/clients/$clientId/documents'
    | '/clients/$clientId/echanges'
    | '/clients/$clientId/facturation'
    | '/clients/$clientId/formations'
    | '/clients/$clientId/journal'
    | '/clients/$clientId/notes'
    | '/clients/$clientId/projets'
    | '/clients/$clientId/questionnaires'
    | '/clients/$clientId/relances'
    | '/clients/$clientId/rendez-vous'
    | '/clients/$clientId/secrets'
    | '/clients/$clientId/soumissions'
    | '/clients/$clientId/taches'
    | '/clients/$clientId/temps'
    | '/clients/$clientId/terms'
    | '/corporate/resolutions/$minuteId'
    | '/projects/$projectRef/cahier'
    | '/projects/$projectRef/livrables'
    | '/projects/$projectRef/recettes'
    | '/prospecting/programs/$programId'
    | '/prospecting/prospects/$prospectId'
    | '/qa/$runId/jouer'
    | '/qa/bugs/$bugRef'
    | '/qa/bugs/nouveau'
    | '/settings/integrations/meta'
    | '/clients/$clientId/'
    | '/corporate/resolutions/'
    | '/qa/bugs/'
    | '/clients/$clientId/rendez-vous/nouvelle'
    | '/clients/$clientId/documents/$documentId'
    | '/clients/$clientId/documents/new'
    | '/clients/$clientId/echanges/$interactionId'
    | '/projects/$projectRef/cahier/$key'
    | '/projects/$projectRef/controles/$key'
    | '/projects/$projectRef/livrables/$key'
    | '/projects/$projectRef/recettes/$key'
    | '/projects/$projectRef/sprints/$sprintId'
    | '/portal/projets/$projectId/cahier/$key'
    | '/portal/projets/$projectId/livrables/$key'
    | '/portal/projets/$projectId/cahier/'
    | '/projects/$projectRef/livrables/$key/recette'
    | '/portal/projets/$projectId/livrables/$key/tester'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/audit'
    | '/design'
    | '/echanges'
    | '/ma-recette'
    | '/memoire'
    | '/relances'
    | '/team'
    | '/time'
    | '/connexion/lien'
    | '/invitation/$token'
    | '/p/$slug'
    | '/portal/acces'
    | '/portal/documents'
    | '/portal/notifications'
    | '/portal/reserver'
    | '/portal/time'
    | '/portal/validations'
    | '/'
    | '/portal'
    | '/corporate/calendrier'
    | '/corporate/exporter'
    | '/corporate/journal'
    | '/corporate/pieces'
    | '/corporate/registres'
    | '/echanges/$interactionId'
    | '/formations/$shortId'
    | '/frais/$expenseNumber'
    | '/meeting-polls/$shortId'
    | '/opportunities/$opportunityId'
    | '/projects/$projectRef'
    | '/qa/$runId'
    | '/questionnaires/$shortId'
    | '/quotes/$quoteNumber'
    | '/settings/api-keys'
    | '/settings/booking'
    | '/settings/emails'
    | '/settings/integrations'
    | '/settings/notifications'
    | '/settings/profile'
    | '/settings/quotes'
    | '/settings/terms'
    | '/tasks/$taskKey'
    | '/validations/$shortId'
    | '/portal/compte/notifications'
    | '/portal/documents/nouveau'
    | '/portal/formations/$videoId'
    | '/portal/livrables/$deliverableId'
    | '/portal/projets/$projectId'
    | '/portal/questionnaires/$questionnaireId'
    | '/portal/rendez-vous/$pollId'
    | '/portal/requests/new'
    | '/portal/reservations/$bookingId'
    | '/portal/sections/$sectionId'
    | '/portal/soumissions/$quoteId'
    | '/portal/tasks/$taskKey'
    | '/clients'
    | '/corporate'
    | '/formations'
    | '/frais'
    | '/opportunities'
    | '/projects'
    | '/prospecting'
    | '/qa'
    | '/questionnaires'
    | '/quotes'
    | '/settings'
    | '/tasks'
    | '/portal/compte'
    | '/portal/formations'
    | '/portal/projets'
    | '/portal/questionnaires'
    | '/portal/rendez-vous'
    | '/portal/soumissions'
    | '/portal/tasks'
    | '/clients/$clientId/affaires'
    | '/clients/$clientId/contacts'
    | '/clients/$clientId/documents'
    | '/clients/$clientId/echanges'
    | '/clients/$clientId/facturation'
    | '/clients/$clientId/formations'
    | '/clients/$clientId/journal'
    | '/clients/$clientId/notes'
    | '/clients/$clientId/projets'
    | '/clients/$clientId/questionnaires'
    | '/clients/$clientId/relances'
    | '/clients/$clientId/rendez-vous'
    | '/clients/$clientId/secrets'
    | '/clients/$clientId/soumissions'
    | '/clients/$clientId/taches'
    | '/clients/$clientId/temps'
    | '/clients/$clientId/terms'
    | '/corporate/resolutions/$minuteId'
    | '/projects/$projectRef/cahier'
    | '/projects/$projectRef/livrables'
    | '/projects/$projectRef/recettes'
    | '/prospecting/programs/$programId'
    | '/prospecting/prospects/$prospectId'
    | '/qa/$runId/jouer'
    | '/qa/bugs/$bugRef'
    | '/qa/bugs/nouveau'
    | '/settings/integrations/meta'
    | '/clients/$clientId'
    | '/corporate/resolutions'
    | '/qa/bugs'
    | '/clients/$clientId/rendez-vous/nouvelle'
    | '/clients/$clientId/documents/$documentId'
    | '/clients/$clientId/documents/new'
    | '/clients/$clientId/echanges/$interactionId'
    | '/projects/$projectRef/cahier/$key'
    | '/projects/$projectRef/controles/$key'
    | '/projects/$projectRef/livrables/$key'
    | '/projects/$projectRef/recettes/$key'
    | '/projects/$projectRef/sprints/$sprintId'
    | '/portal/projets/$projectId/cahier/$key'
    | '/portal/projets/$projectId/livrables/$key'
    | '/portal/projets/$projectId/cahier'
    | '/projects/$projectRef/livrables/$key/recette'
    | '/portal/projets/$projectId/livrables/$key/tester'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/portal'
    | '/_app/audit'
    | '/_app/corporate'
    | '/_app/design'
    | '/_app/echanges'
    | '/_app/ma-recette'
    | '/_app/memoire'
    | '/_app/relances'
    | '/_app/settings'
    | '/_app/tasks'
    | '/_app/team'
    | '/_app/time'
    | '/connexion/lien'
    | '/invitation/$token'
    | '/p/$slug'
    | '/portal/acces'
    | '/portal/compte'
    | '/portal/documents'
    | '/portal/notifications'
    | '/portal/reserver'
    | '/portal/time'
    | '/portal/validations'
    | '/_app/'
    | '/portal/'
    | '/_app/clients/$clientId'
    | '/_app/corporate/calendrier'
    | '/_app/corporate/exporter'
    | '/_app/corporate/journal'
    | '/_app/corporate/pieces'
    | '/_app/corporate/registres'
    | '/_app/echanges/$interactionId'
    | '/_app/formations/$shortId'
    | '/_app/frais/$expenseNumber'
    | '/_app/meeting-polls/$shortId'
    | '/_app/opportunities/$opportunityId'
    | '/_app/projects/$projectRef'
    | '/_app/qa/$runId'
    | '/_app/questionnaires/$shortId'
    | '/_app/quotes/$quoteNumber'
    | '/_app/settings/api-keys'
    | '/_app/settings/booking'
    | '/_app/settings/emails'
    | '/_app/settings/integrations'
    | '/_app/settings/notifications'
    | '/_app/settings/profile'
    | '/_app/settings/quotes'
    | '/_app/settings/terms'
    | '/_app/tasks/$taskKey'
    | '/_app/validations/$shortId'
    | '/portal/compte/notifications'
    | '/portal/documents_/nouveau'
    | '/portal/formations/$videoId'
    | '/portal/livrables/$deliverableId'
    | '/portal/projets/$projectId'
    | '/portal/questionnaires/$questionnaireId'
    | '/portal/rendez-vous/$pollId'
    | '/portal/requests/new'
    | '/portal/reservations/$bookingId'
    | '/portal/sections/$sectionId'
    | '/portal/soumissions/$quoteId'
    | '/portal/tasks/$taskKey'
    | '/_app/clients/'
    | '/_app/corporate/'
    | '/_app/formations/'
    | '/_app/frais/'
    | '/_app/opportunities/'
    | '/_app/projects/'
    | '/_app/prospecting/'
    | '/_app/qa/'
    | '/_app/questionnaires/'
    | '/_app/quotes/'
    | '/_app/settings/'
    | '/_app/tasks/'
    | '/portal/compte/'
    | '/portal/formations/'
    | '/portal/projets/'
    | '/portal/questionnaires/'
    | '/portal/rendez-vous/'
    | '/portal/soumissions/'
    | '/portal/tasks/'
    | '/_app/clients/$clientId/affaires'
    | '/_app/clients/$clientId/contacts'
    | '/_app/clients/$clientId/documents'
    | '/_app/clients/$clientId/echanges'
    | '/_app/clients/$clientId/facturation'
    | '/_app/clients/$clientId/formations'
    | '/_app/clients/$clientId/journal'
    | '/_app/clients/$clientId/notes'
    | '/_app/clients/$clientId/projets'
    | '/_app/clients/$clientId/questionnaires'
    | '/_app/clients/$clientId/relances'
    | '/_app/clients/$clientId/rendez-vous'
    | '/_app/clients/$clientId/secrets'
    | '/_app/clients/$clientId/soumissions'
    | '/_app/clients/$clientId/taches'
    | '/_app/clients/$clientId/temps'
    | '/_app/clients/$clientId/terms'
    | '/_app/corporate/resolutions/$minuteId'
    | '/_app/projects/$projectRef_/cahier'
    | '/_app/projects/$projectRef_/livrables'
    | '/_app/projects/$projectRef_/recettes'
    | '/_app/prospecting/programs/$programId'
    | '/_app/prospecting/prospects/$prospectId'
    | '/_app/qa/$runId_/jouer'
    | '/_app/qa/bugs/$bugRef'
    | '/_app/qa/bugs/nouveau'
    | '/_app/settings/integrations_/meta'
    | '/_app/clients/$clientId/'
    | '/_app/corporate/resolutions/'
    | '/_app/qa/bugs/'
    | '/_app/clients/$clientId/rendez-vous_/nouvelle'
    | '/_app/clients/$clientId_/documents/$documentId'
    | '/_app/clients/$clientId_/documents/new'
    | '/_app/clients/$clientId_/echanges/$interactionId'
    | '/_app/projects/$projectRef_/cahier_/$key'
    | '/_app/projects/$projectRef_/controles_/$key'
    | '/_app/projects/$projectRef_/livrables_/$key'
    | '/_app/projects/$projectRef_/recettes_/$key'
    | '/_app/projects/$projectRef_/sprints/$sprintId'
    | '/portal/projets/$projectId_/cahier/$key'
    | '/portal/projets/$projectId_/livrables/$key'
    | '/portal/projets/$projectId_/cahier/'
    | '/_app/projects/$projectRef_/livrables_/$key_/recette'
    | '/portal/projets/$projectId_/livrables/$key_/tester'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  PortalRoute: typeof PortalRouteWithChildren
  ConnexionLienRoute: typeof ConnexionLienRoute
  InvitationTokenRoute: typeof InvitationTokenRoute
  PSlugRoute: typeof PSlugRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal': {
      id: '/portal'
      path: '/portal'
      fullPath: '/portal'
      preLoaderRoute: typeof PortalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/audit': {
      id: '/_app/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AppAuditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/corporate': {
      id: '/_app/corporate'
      path: '/corporate'
      fullPath: '/corporate'
      preLoaderRoute: typeof AppCorporateRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/design': {
      id: '/_app/design'
      path: '/design'
      fullPath: '/design'
      preLoaderRoute: typeof AppDesignRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/echanges': {
      id: '/_app/echanges'
      path: '/echanges'
      fullPath: '/echanges'
      preLoaderRoute: typeof AppEchangesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ma-recette': {
      id: '/_app/ma-recette'
      path: '/ma-recette'
      fullPath: '/ma-recette'
      preLoaderRoute: typeof AppMaRecetteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/memoire': {
      id: '/_app/memoire'
      path: '/memoire'
      fullPath: '/memoire'
      preLoaderRoute: typeof AppMemoireRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/relances': {
      id: '/_app/relances'
      path: '/relances'
      fullPath: '/relances'
      preLoaderRoute: typeof AppRelancesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tasks': {
      id: '/_app/tasks'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof AppTasksRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/team': {
      id: '/_app/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof AppTeamRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/time': {
      id: '/_app/time'
      path: '/time'
      fullPath: '/time'
      preLoaderRoute: typeof AppTimeRouteImport
      parentRoute: typeof AppRoute
    }
    '/connexion/lien': {
      id: '/connexion/lien'
      path: '/connexion/lien'
      fullPath: '/connexion/lien'
      preLoaderRoute: typeof ConnexionLienRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invitation/$token': {
      id: '/invitation/$token'
      path: '/invitation/$token'
      fullPath: '/invitation/$token'
      preLoaderRoute: typeof InvitationTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/p/$slug': {
      id: '/p/$slug'
      path: '/p/$slug'
      fullPath: '/p/$slug'
      preLoaderRoute: typeof PSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/': {
      id: '/portal/'
      path: '/'
      fullPath: '/portal/'
      preLoaderRoute: typeof PortalIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/acces': {
      id: '/portal/acces'
      path: '/acces'
      fullPath: '/portal/acces'
      preLoaderRoute: typeof PortalAccesRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/compte': {
      id: '/portal/compte'
      path: '/compte'
      fullPath: '/portal/compte'
      preLoaderRoute: typeof PortalCompteRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/documents': {
      id: '/portal/documents'
      path: '/documents'
      fullPath: '/portal/documents'
      preLoaderRoute: typeof PortalDocumentsRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/notifications': {
      id: '/portal/notifications'
      path: '/notifications'
      fullPath: '/portal/notifications'
      preLoaderRoute: typeof PortalNotificationsRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/reserver': {
      id: '/portal/reserver'
      path: '/reserver'
      fullPath: '/portal/reserver'
      preLoaderRoute: typeof PortalReserverRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/time': {
      id: '/portal/time'
      path: '/time'
      fullPath: '/portal/time'
      preLoaderRoute: typeof PortalTimeRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/validations': {
      id: '/portal/validations'
      path: '/validations'
      fullPath: '/portal/validations'
      preLoaderRoute: typeof PortalValidationsRouteImport
      parentRoute: typeof PortalRoute
    }
    '/_app/clients/': {
      id: '/_app/clients/'
      path: '/clients'
      fullPath: '/clients/'
      preLoaderRoute: typeof AppClientsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/clients/$clientId': {
      id: '/_app/clients/$clientId'
      path: '/clients/$clientId'
      fullPath: '/clients/$clientId'
      preLoaderRoute: typeof AppClientsClientIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/corporate/': {
      id: '/_app/corporate/'
      path: '/'
      fullPath: '/corporate/'
      preLoaderRoute: typeof AppCorporateIndexRouteImport
      parentRoute: typeof AppCorporateRoute
    }
    '/_app/corporate/calendrier': {
      id: '/_app/corporate/calendrier'
      path: '/calendrier'
      fullPath: '/corporate/calendrier'
      preLoaderRoute: typeof AppCorporateCalendrierRouteImport
      parentRoute: typeof AppCorporateRoute
    }
    '/_app/corporate/exporter': {
      id: '/_app/corporate/exporter'
      path: '/exporter'
      fullPath: '/corporate/exporter'
      preLoaderRoute: typeof AppCorporateExporterRouteImport
      parentRoute: typeof AppCorporateRoute
    }
    '/_app/corporate/journal': {
      id: '/_app/corporate/journal'
      path: '/journal'
      fullPath: '/corporate/journal'
      preLoaderRoute: typeof AppCorporateJournalRouteImport
      parentRoute: typeof AppCorporateRoute
    }
    '/_app/corporate/pieces': {
      id: '/_app/corporate/pieces'
      path: '/pieces'
      fullPath: '/corporate/pieces'
      preLoaderRoute: typeof AppCorporatePiecesRouteImport
      parentRoute: typeof AppCorporateRoute
    }
    '/_app/corporate/registres': {
      id: '/_app/corporate/registres'
      path: '/registres'
      fullPath: '/corporate/registres'
      preLoaderRoute: typeof AppCorporateRegistresRouteImport
      parentRoute: typeof AppCorporateRoute
    }
    '/_app/echanges/$interactionId': {
      id: '/_app/echanges/$interactionId'
      path: '/$interactionId'
      fullPath: '/echanges/$interactionId'
      preLoaderRoute: typeof AppEchangesInteractionIdRouteImport
      parentRoute: typeof AppEchangesRoute
    }
    '/_app/formations/': {
      id: '/_app/formations/'
      path: '/formations'
      fullPath: '/formations/'
      preLoaderRoute: typeof AppFormationsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/formations/$shortId': {
      id: '/_app/formations/$shortId'
      path: '/formations/$shortId'
      fullPath: '/formations/$shortId'
      preLoaderRoute: typeof AppFormationsShortIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/frais/': {
      id: '/_app/frais/'
      path: '/frais'
      fullPath: '/frais/'
      preLoaderRoute: typeof AppFraisIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/frais/$expenseNumber': {
      id: '/_app/frais/$expenseNumber'
      path: '/frais/$expenseNumber'
      fullPath: '/frais/$expenseNumber'
      preLoaderRoute: typeof AppFraisExpenseNumberRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/meeting-polls/$shortId': {
      id: '/_app/meeting-polls/$shortId'
      path: '/meeting-polls/$shortId'
      fullPath: '/meeting-polls/$shortId'
      preLoaderRoute: typeof AppMeetingPollsShortIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/opportunities/': {
      id: '/_app/opportunities/'
      path: '/opportunities'
      fullPath: '/opportunities/'
      preLoaderRoute: typeof AppOpportunitiesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/opportunities/$opportunityId': {
      id: '/_app/opportunities/$opportunityId'
      path: '/opportunities/$opportunityId'
      fullPath: '/opportunities/$opportunityId'
      preLoaderRoute: typeof AppOpportunitiesOpportunityIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/': {
      id: '/_app/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof AppProjectsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/$projectRef': {
      id: '/_app/projects/$projectRef'
      path: '/projects/$projectRef'
      fullPath: '/projects/$projectRef'
      preLoaderRoute: typeof AppProjectsProjectRefRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/prospecting/': {
      id: '/_app/prospecting/'
      path: '/prospecting'
      fullPath: '/prospecting/'
      preLoaderRoute: typeof AppProspectingIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/qa/': {
      id: '/_app/qa/'
      path: '/qa'
      fullPath: '/qa/'
      preLoaderRoute: typeof AppQaIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/qa/$runId': {
      id: '/_app/qa/$runId'
      path: '/qa/$runId'
      fullPath: '/qa/$runId'
      preLoaderRoute: typeof AppQaRunIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/questionnaires/': {
      id: '/_app/questionnaires/'
      path: '/questionnaires'
      fullPath: '/questionnaires/'
      preLoaderRoute: typeof AppQuestionnairesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/questionnaires/$shortId': {
      id: '/_app/questionnaires/$shortId'
      path: '/questionnaires/$shortId'
      fullPath: '/questionnaires/$shortId'
      preLoaderRoute: typeof AppQuestionnairesShortIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/quotes/': {
      id: '/_app/quotes/'
      path: '/quotes'
      fullPath: '/quotes/'
      preLoaderRoute: typeof AppQuotesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/quotes/$quoteNumber': {
      id: '/_app/quotes/$quoteNumber'
      path: '/quotes/$quoteNumber'
      fullPath: '/quotes/$quoteNumber'
      preLoaderRoute: typeof AppQuotesQuoteNumberRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/api-keys': {
      id: '/_app/settings/api-keys'
      path: '/api-keys'
      fullPath: '/settings/api-keys'
      preLoaderRoute: typeof AppSettingsApiKeysRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/booking': {
      id: '/_app/settings/booking'
      path: '/booking'
      fullPath: '/settings/booking'
      preLoaderRoute: typeof AppSettingsBookingRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/emails': {
      id: '/_app/settings/emails'
      path: '/emails'
      fullPath: '/settings/emails'
      preLoaderRoute: typeof AppSettingsEmailsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/integrations': {
      id: '/_app/settings/integrations'
      path: '/integrations'
      fullPath: '/settings/integrations'
      preLoaderRoute: typeof AppSettingsIntegrationsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/notifications': {
      id: '/_app/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AppSettingsNotificationsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/profile': {
      id: '/_app/settings/profile'
      path: '/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof AppSettingsProfileRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/quotes': {
      id: '/_app/settings/quotes'
      path: '/quotes'
      fullPath: '/settings/quotes'
      preLoaderRoute: typeof AppSettingsQuotesRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/terms': {
      id: '/_app/settings/terms'
      path: '/terms'
      fullPath: '/settings/terms'
      preLoaderRoute: typeof AppSettingsTermsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/tasks/': {
      id: '/_app/tasks/'
      path: '/'
      fullPath: '/tasks/'
      preLoaderRoute: typeof AppTasksIndexRouteImport
      parentRoute: typeof AppTasksRoute
    }
    '/_app/tasks/$taskKey': {
      id: '/_app/tasks/$taskKey'
      path: '/$taskKey'
      fullPath: '/tasks/$taskKey'
      preLoaderRoute: typeof AppTasksTaskKeyRouteImport
      parentRoute: typeof AppTasksRoute
    }
    '/_app/validations/$shortId': {
      id: '/_app/validations/$shortId'
      path: '/validations/$shortId'
      fullPath: '/validations/$shortId'
      preLoaderRoute: typeof AppValidationsShortIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/portal/compte/': {
      id: '/portal/compte/'
      path: '/'
      fullPath: '/portal/compte/'
      preLoaderRoute: typeof PortalCompteIndexRouteImport
      parentRoute: typeof PortalCompteRoute
    }
    '/portal/compte/notifications': {
      id: '/portal/compte/notifications'
      path: '/notifications'
      fullPath: '/portal/compte/notifications'
      preLoaderRoute: typeof PortalCompteNotificationsRouteImport
      parentRoute: typeof PortalCompteRoute
    }
    '/portal/documents_/nouveau': {
      id: '/portal/documents_/nouveau'
      path: '/documents/nouveau'
      fullPath: '/portal/documents/nouveau'
      preLoaderRoute: typeof PortalDocumentsNouveauRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/formations/': {
      id: '/portal/formations/'
      path: '/formations'
      fullPath: '/portal/formations/'
      preLoaderRoute: typeof PortalFormationsIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/formations/$videoId': {
      id: '/portal/formations/$videoId'
      path: '/formations/$videoId'
      fullPath: '/portal/formations/$videoId'
      preLoaderRoute: typeof PortalFormationsVideoIdRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/livrables/$deliverableId': {
      id: '/portal/livrables/$deliverableId'
      path: '/livrables/$deliverableId'
      fullPath: '/portal/livrables/$deliverableId'
      preLoaderRoute: typeof PortalLivrablesDeliverableIdRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/projets/': {
      id: '/portal/projets/'
      path: '/projets'
      fullPath: '/portal/projets/'
      preLoaderRoute: typeof PortalProjetsIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/projets/$projectId': {
      id: '/portal/projets/$projectId'
      path: '/projets/$projectId'
      fullPath: '/portal/projets/$projectId'
      preLoaderRoute: typeof PortalProjetsProjectIdRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/questionnaires/': {
      id: '/portal/questionnaires/'
      path: '/questionnaires'
      fullPath: '/portal/questionnaires/'
      preLoaderRoute: typeof PortalQuestionnairesIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/questionnaires/$questionnaireId': {
      id: '/portal/questionnaires/$questionnaireId'
      path: '/questionnaires/$questionnaireId'
      fullPath: '/portal/questionnaires/$questionnaireId'
      preLoaderRoute: typeof PortalQuestionnairesQuestionnaireIdRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/rendez-vous/': {
      id: '/portal/rendez-vous/'
      path: '/rendez-vous'
      fullPath: '/portal/rendez-vous/'
      preLoaderRoute: typeof PortalRendezVousIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/rendez-vous/$pollId': {
      id: '/portal/rendez-vous/$pollId'
      path: '/rendez-vous/$pollId'
      fullPath: '/portal/rendez-vous/$pollId'
      preLoaderRoute: typeof PortalRendezVousPollIdRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/requests/new': {
      id: '/portal/requests/new'
      path: '/requests/new'
      fullPath: '/portal/requests/new'
      preLoaderRoute: typeof PortalRequestsNewRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/reservations/$bookingId': {
      id: '/portal/reservations/$bookingId'
      path: '/reservations/$bookingId'
      fullPath: '/portal/reservations/$bookingId'
      preLoaderRoute: typeof PortalReservationsBookingIdRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/sections/$sectionId': {
      id: '/portal/sections/$sectionId'
      path: '/sections/$sectionId'
      fullPath: '/portal/sections/$sectionId'
      preLoaderRoute: typeof PortalSectionsSectionIdRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/soumissions/': {
      id: '/portal/soumissions/'
      path: '/soumissions'
      fullPath: '/portal/soumissions/'
      preLoaderRoute: typeof PortalSoumissionsIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/soumissions/$quoteId': {
      id: '/portal/soumissions/$quoteId'
      path: '/soumissions/$quoteId'
      fullPath: '/portal/soumissions/$quoteId'
      preLoaderRoute: typeof PortalSoumissionsQuoteIdRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/tasks/': {
      id: '/portal/tasks/'
      path: '/tasks'
      fullPath: '/portal/tasks/'
      preLoaderRoute: typeof PortalTasksIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/tasks/$taskKey': {
      id: '/portal/tasks/$taskKey'
      path: '/tasks/$taskKey'
      fullPath: '/portal/tasks/$taskKey'
      preLoaderRoute: typeof PortalTasksTaskKeyRouteImport
      parentRoute: typeof PortalRoute
    }
    '/_app/clients/$clientId/': {
      id: '/_app/clients/$clientId/'
      path: '/'
      fullPath: '/clients/$clientId/'
      preLoaderRoute: typeof AppClientsClientIdIndexRouteImport
      parentRoute: typeof AppClientsClientIdRoute
    }
    '/_app/clients/$clientId/affaires': {
      id: '/_app/clients/$clientId/affaires'
      path: '/affaires'
      fullPath: '/clients/$clientId/affaires'
      preLoaderRoute: typeof AppClientsClientIdAffairesRouteImport
      parentRoute: typeof AppClientsClientIdRoute
    }
    '/_app/clients/$clientId/contacts': {
      id: '/_app/clients/$clientId/contacts'
      path: '/contacts'
      fullPath: '/clients/$clientId/contacts'
      preLoaderRoute: typeof AppClientsClientIdContactsRouteImport
      parentRoute: typeof AppClientsClientIdRoute
    }
    '/_app/clients/$clientId/documents': {
      id: '/_app/clients/$clientId/documents'
      path: '/documents'
      fullPath: '/clients/$clientId/documents'
      preLoaderRoute: typeof AppClientsClientIdDocumentsRouteImport
      parentRoute: typeof AppClientsClientIdRoute
    }
    '/_app/clients/$clientId/echanges': {
      id: '/_app/clients/$clientId/echanges'
      path: '/echanges'
      fullPath: '/clients/$clientId/echanges'
      preLoaderRoute: typeof AppClientsClientIdEchangesRouteImport
      parentRoute: typeof AppClientsClientIdRoute
    }
    '/_app/clients/$clientId/facturation': {
      id: '/_app/clients/$clientId/facturation'
      path: '/facturation'
      fullPath: '/clients/$clientId/facturation'
      preLoaderRoute: typeof AppClientsClientIdFacturationRouteImport
      parentRoute: typeof AppClientsClientIdRoute
    }
    '/_app/clients/$clientId/formations': {
      id: '/_app/clients/$clientId/formations'
      path: '/formations'
      fullPath: '/clients/$clientId/formations'
      preLoaderRoute: typeof AppClientsClientIdFormationsRouteImport
      parentRoute: typeof AppClientsClientIdRoute
    }
    '/_app/clients/$clientId/journal': {
      id: '/_app/clients/$clientId/journal'
      path: '/journal'
      fullPath: '/clients/$clientId/journal'
      preLoaderRoute: typeof AppClientsClientIdJournalRouteImport
      parentRoute: typeof AppClientsClientIdRoute
    }
    '/_app/clients/$clientId/notes': {
      id: '/_app/clients/$clientId/notes'
      path: '/notes'
      fullPath: '/clients/$clientId/notes'
      preLoaderRoute: typeof AppClientsClientIdNotesRouteImport
      parentRoute: typeof AppClientsClientIdRoute
    }
    '/_app/clients/$clientId/projets': {
      id: '/_app/clients/$clientId/projets'
      path: '/projets'
      fullPath: '/clients/$clientId/projets'
      preLoaderRoute: typeof AppClientsClientIdProjetsRouteImport
      parentRoute: typeof AppClientsClientIdRoute
    }
    '/_app/clients/$clientId/questionnaires': {
      id: '/_app/clients/$clientId/questionnaires'
      path: '/questionnaires'
      fullPath: '/clients/$clientId/questionnaires'
      preLoaderRoute: typeof AppClientsClientIdQuestionnairesRouteImport
      parentRoute: typeof AppClientsClientIdRoute
    }
    '/_app/clients/$clientId/relances': {
      id: '/_app/clients/$clientId/relances'
      path: '/relances'
      fullPath: '/clients/$clientId/relances'
      preLoaderRoute: typeof AppClientsClientIdRelancesRouteImport
      parentRoute: typeof AppClientsClientIdRoute
    }
    '/_app/clients/$clientId/rendez-vous': {
      id: '/_app/clients/$clientId/rendez-vous'
      path: '/rendez-vous'
      fullPath: '/clients/$clientId/rendez-vous'
      preLoaderRoute: typeof AppClientsClientIdRendezVousRouteImport
      parentRoute: typeof AppClientsClientIdRoute
    }
    '/_app/clients/$clientId/secrets': {
      id: '/_app/clients/$clientId/secrets'
      path: '/secrets'
      fullPath: '/clients/$clientId/secrets'
      preLoaderRoute: typeof AppClientsClientIdSecretsRouteImport
      parentRoute: typeof AppClientsClientIdRoute
    }
    '/_app/clients/$clientId/soumissions': {
      id: '/_app/clients/$clientId/soumissions'
      path: '/soumissions'
      fullPath: '/clients/$clientId/soumissions'
      preLoaderRoute: typeof AppClientsClientIdSoumissionsRouteImport
      parentRoute: typeof AppClientsClientIdRoute
    }
    '/_app/clients/$clientId/taches': {
      id: '/_app/clients/$clientId/taches'
      path: '/taches'
      fullPath: '/clients/$clientId/taches'
      preLoaderRoute: typeof AppClientsClientIdTachesRouteImport
      parentRoute: typeof AppClientsClientIdRoute
    }
    '/_app/clients/$clientId/temps': {
      id: '/_app/clients/$clientId/temps'
      path: '/temps'
      fullPath: '/clients/$clientId/temps'
      preLoaderRoute: typeof AppClientsClientIdTempsRouteImport
      parentRoute: typeof AppClientsClientIdRoute
    }
    '/_app/clients/$clientId/terms': {
      id: '/_app/clients/$clientId/terms'
      path: '/terms'
      fullPath: '/clients/$clientId/terms'
      preLoaderRoute: typeof AppClientsClientIdTermsRouteImport
      parentRoute: typeof AppClientsClientIdRoute
    }
    '/_app/corporate/resolutions/': {
      id: '/_app/corporate/resolutions/'
      path: '/resolutions'
      fullPath: '/corporate/resolutions/'
      preLoaderRoute: typeof AppCorporateResolutionsIndexRouteImport
      parentRoute: typeof AppCorporateRoute
    }
    '/_app/corporate/resolutions/$minuteId': {
      id: '/_app/corporate/resolutions/$minuteId'
      path: '/resolutions/$minuteId'
      fullPath: '/corporate/resolutions/$minuteId'
      preLoaderRoute: typeof AppCorporateResolutionsMinuteIdRouteImport
      parentRoute: typeof AppCorporateRoute
    }
    '/_app/projects/$projectRef_/cahier': {
      id: '/_app/projects/$projectRef_/cahier'
      path: '/projects/$projectRef/cahier'
      fullPath: '/projects/$projectRef/cahier'
      preLoaderRoute: typeof AppProjectsProjectRefCahierRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/$projectRef_/livrables': {
      id: '/_app/projects/$projectRef_/livrables'
      path: '/projects/$projectRef/livrables'
      fullPath: '/projects/$projectRef/livrables'
      preLoaderRoute: typeof AppProjectsProjectRefLivrablesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/$projectRef_/recettes': {
      id: '/_app/projects/$projectRef_/recettes'
      path: '/projects/$projectRef/recettes'
      fullPath: '/projects/$projectRef/recettes'
      preLoaderRoute: typeof AppProjectsProjectRefRecettesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/prospecting/programs/$programId': {
      id: '/_app/prospecting/programs/$programId'
      path: '/prospecting/programs/$programId'
      fullPath: '/prospecting/programs/$programId'
      preLoaderRoute: typeof AppProspectingProgramsProgramIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/prospecting/prospects/$prospectId': {
      id: '/_app/prospecting/prospects/$prospectId'
      path: '/prospecting/prospects/$prospectId'
      fullPath: '/prospecting/prospects/$prospectId'
      preLoaderRoute: typeof AppProspectingProspectsProspectIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/qa/$runId_/jouer': {
      id: '/_app/qa/$runId_/jouer'
      path: '/qa/$runId/jouer'
      fullPath: '/qa/$runId/jouer'
      preLoaderRoute: typeof AppQaRunIdJouerRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/qa/bugs/': {
      id: '/_app/qa/bugs/'
      path: '/qa/bugs'
      fullPath: '/qa/bugs/'
      preLoaderRoute: typeof AppQaBugsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/qa/bugs/$bugRef': {
      id: '/_app/qa/bugs/$bugRef'
      path: '/qa/bugs/$bugRef'
      fullPath: '/qa/bugs/$bugRef'
      preLoaderRoute: typeof AppQaBugsBugRefRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/qa/bugs/nouveau': {
      id: '/_app/qa/bugs/nouveau'
      path: '/qa/bugs/nouveau'
      fullPath: '/qa/bugs/nouveau'
      preLoaderRoute: typeof AppQaBugsNouveauRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/integrations_/meta': {
      id: '/_app/settings/integrations_/meta'
      path: '/integrations/meta'
      fullPath: '/settings/integrations/meta'
      preLoaderRoute: typeof AppSettingsIntegrationsMetaRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/clients/$clientId/rendez-vous_/nouvelle': {
      id: '/_app/clients/$clientId/rendez-vous_/nouvelle'
      path: '/rendez-vous/nouvelle'
      fullPath: '/clients/$clientId/rendez-vous/nouvelle'
      preLoaderRoute: typeof AppClientsClientIdRendezVousNouvelleRouteImport
      parentRoute: typeof AppClientsClientIdRoute
    }
    '/_app/clients/$clientId_/documents/$documentId': {
      id: '/_app/clients/$clientId_/documents/$documentId'
      path: '/clients/$clientId/documents/$documentId'
      fullPath: '/clients/$clientId/documents/$documentId'
      preLoaderRoute: typeof AppClientsClientIdDocumentsDocumentIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/clients/$clientId_/documents/new': {
      id: '/_app/clients/$clientId_/documents/new'
      path: '/clients/$clientId/documents/new'
      fullPath: '/clients/$clientId/documents/new'
      preLoaderRoute: typeof AppClientsClientIdDocumentsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/clients/$clientId_/echanges/$interactionId': {
      id: '/_app/clients/$clientId_/echanges/$interactionId'
      path: '/clients/$clientId/echanges/$interactionId'
      fullPath: '/clients/$clientId/echanges/$interactionId'
      preLoaderRoute: typeof AppClientsClientIdEchangesInteractionIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/$projectRef_/cahier_/$key': {
      id: '/_app/projects/$projectRef_/cahier_/$key'
      path: '/projects/$projectRef/cahier/$key'
      fullPath: '/projects/$projectRef/cahier/$key'
      preLoaderRoute: typeof AppProjectsProjectRefCahierKeyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/$projectRef_/controles_/$key': {
      id: '/_app/projects/$projectRef_/controles_/$key'
      path: '/projects/$projectRef/controles/$key'
      fullPath: '/projects/$projectRef/controles/$key'
      preLoaderRoute: typeof AppProjectsProjectRefControlesKeyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/$projectRef_/livrables_/$key': {
      id: '/_app/projects/$projectRef_/livrables_/$key'
      path: '/projects/$projectRef/livrables/$key'
      fullPath: '/projects/$projectRef/livrables/$key'
      preLoaderRoute: typeof AppProjectsProjectRefLivrablesKeyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/$projectRef_/recettes_/$key': {
      id: '/_app/projects/$projectRef_/recettes_/$key'
      path: '/projects/$projectRef/recettes/$key'
      fullPath: '/projects/$projectRef/recettes/$key'
      preLoaderRoute: typeof AppProjectsProjectRefRecettesKeyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/$projectRef_/sprints/$sprintId': {
      id: '/_app/projects/$projectRef_/sprints/$sprintId'
      path: '/projects/$projectRef/sprints/$sprintId'
      fullPath: '/projects/$projectRef/sprints/$sprintId'
      preLoaderRoute: typeof AppProjectsProjectRefSprintsSprintIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/portal/projets/$projectId_/cahier/': {
      id: '/portal/projets/$projectId_/cahier/'
      path: '/projets/$projectId/cahier'
      fullPath: '/portal/projets/$projectId/cahier/'
      preLoaderRoute: typeof PortalProjetsProjectIdCahierIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/projets/$projectId_/cahier/$key': {
      id: '/portal/projets/$projectId_/cahier/$key'
      path: '/projets/$projectId/cahier/$key'
      fullPath: '/portal/projets/$projectId/cahier/$key'
      preLoaderRoute: typeof PortalProjetsProjectIdCahierKeyRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/projets/$projectId_/livrables/$key': {
      id: '/portal/projets/$projectId_/livrables/$key'
      path: '/projets/$projectId/livrables/$key'
      fullPath: '/portal/projets/$projectId/livrables/$key'
      preLoaderRoute: typeof PortalProjetsProjectIdLivrablesKeyRouteImport
      parentRoute: typeof PortalRoute
    }
    '/_app/projects/$projectRef_/livrables_/$key_/recette': {
      id: '/_app/projects/$projectRef_/livrables_/$key_/recette'
      path: '/projects/$projectRef/livrables/$key/recette'
      fullPath: '/projects/$projectRef/livrables/$key/recette'
      preLoaderRoute: typeof AppProjectsProjectRefLivrablesKeyRecetteRouteImport
      parentRoute: typeof AppRoute
    }
    '/portal/projets/$projectId_/livrables/$key_/tester': {
      id: '/portal/projets/$projectId_/livrables/$key_/tester'
      path: '/projets/$projectId/livrables/$key/tester'
      fullPath: '/portal/projets/$projectId/livrables/$key/tester'
      preLoaderRoute: typeof PortalProjetsProjectIdLivrablesKeyTesterRouteImport
      parentRoute: typeof PortalRoute
    }
  }
}

interface AppCorporateRouteChildren {
  AppCorporateCalendrierRoute: typeof AppCorporateCalendrierRoute
  AppCorporateExporterRoute: typeof AppCorporateExporterRoute
  AppCorporateJournalRoute: typeof AppCorporateJournalRoute
  AppCorporatePiecesRoute: typeof AppCorporatePiecesRoute
  AppCorporateRegistresRoute: typeof AppCorporateRegistresRoute
  AppCorporateIndexRoute: typeof AppCorporateIndexRoute
  AppCorporateResolutionsMinuteIdRoute: typeof AppCorporateResolutionsMinuteIdRoute
  AppCorporateResolutionsIndexRoute: typeof AppCorporateResolutionsIndexRoute
}

const AppCorporateRouteChildren: AppCorporateRouteChildren = {
  AppCorporateCalendrierRoute: AppCorporateCalendrierRoute,
  AppCorporateExporterRoute: AppCorporateExporterRoute,
  AppCorporateJournalRoute: AppCorporateJournalRoute,
  AppCorporatePiecesRoute: AppCorporatePiecesRoute,
  AppCorporateRegistresRoute: AppCorporateRegistresRoute,
  AppCorporateIndexRoute: AppCorporateIndexRoute,
  AppCorporateResolutionsMinuteIdRoute: AppCorporateResolutionsMinuteIdRoute,
  AppCorporateResolutionsIndexRoute: AppCorporateResolutionsIndexRoute,
}

const AppCorporateRouteWithChildren = AppCorporateRoute._addFileChildren(
  AppCorporateRouteChildren,
)

interface AppEchangesRouteChildren {
  AppEchangesInteractionIdRoute: typeof AppEchangesInteractionIdRoute
}

const AppEchangesRouteChildren: AppEchangesRouteChildren = {
  AppEchangesInteractionIdRoute: AppEchangesInteractionIdRoute,
}

const AppEchangesRouteWithChildren = AppEchangesRoute._addFileChildren(
  AppEchangesRouteChildren,
)

interface AppSettingsRouteChildren {
  AppSettingsApiKeysRoute: typeof AppSettingsApiKeysRoute
  AppSettingsBookingRoute: typeof AppSettingsBookingRoute
  AppSettingsEmailsRoute: typeof AppSettingsEmailsRoute
  AppSettingsIntegrationsRoute: typeof AppSettingsIntegrationsRoute
  AppSettingsNotificationsRoute: typeof AppSettingsNotificationsRoute
  AppSettingsProfileRoute: typeof AppSettingsProfileRoute
  AppSettingsQuotesRoute: typeof AppSettingsQuotesRoute
  AppSettingsTermsRoute: typeof AppSettingsTermsRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
  AppSettingsIntegrationsMetaRoute: typeof AppSettingsIntegrationsMetaRoute
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsApiKeysRoute: AppSettingsApiKeysRoute,
  AppSettingsBookingRoute: AppSettingsBookingRoute,
  AppSettingsEmailsRoute: AppSettingsEmailsRoute,
  AppSettingsIntegrationsRoute: AppSettingsIntegrationsRoute,
  AppSettingsNotificationsRoute: AppSettingsNotificationsRoute,
  AppSettingsProfileRoute: AppSettingsProfileRoute,
  AppSettingsQuotesRoute: AppSettingsQuotesRoute,
  AppSettingsTermsRoute: AppSettingsTermsRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
  AppSettingsIntegrationsMetaRoute: AppSettingsIntegrationsMetaRoute,
}

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
)

interface AppTasksRouteChildren {
  AppTasksTaskKeyRoute: typeof AppTasksTaskKeyRoute
  AppTasksIndexRoute: typeof AppTasksIndexRoute
}

const AppTasksRouteChildren: AppTasksRouteChildren = {
  AppTasksTaskKeyRoute: AppTasksTaskKeyRoute,
  AppTasksIndexRoute: AppTasksIndexRoute,
}

const AppTasksRouteWithChildren = AppTasksRoute._addFileChildren(
  AppTasksRouteChildren,
)

interface AppClientsClientIdRouteChildren {
  AppClientsClientIdAffairesRoute: typeof AppClientsClientIdAffairesRoute
  AppClientsClientIdContactsRoute: typeof AppClientsClientIdContactsRoute
  AppClientsClientIdDocumentsRoute: typeof AppClientsClientIdDocumentsRoute
  AppClientsClientIdEchangesRoute: typeof AppClientsClientIdEchangesRoute
  AppClientsClientIdFacturationRoute: typeof AppClientsClientIdFacturationRoute
  AppClientsClientIdFormationsRoute: typeof AppClientsClientIdFormationsRoute
  AppClientsClientIdJournalRoute: typeof AppClientsClientIdJournalRoute
  AppClientsClientIdNotesRoute: typeof AppClientsClientIdNotesRoute
  AppClientsClientIdProjetsRoute: typeof AppClientsClientIdProjetsRoute
  AppClientsClientIdQuestionnairesRoute: typeof AppClientsClientIdQuestionnairesRoute
  AppClientsClientIdRelancesRoute: typeof AppClientsClientIdRelancesRoute
  AppClientsClientIdRendezVousRoute: typeof AppClientsClientIdRendezVousRoute
  AppClientsClientIdSecretsRoute: typeof AppClientsClientIdSecretsRoute
  AppClientsClientIdSoumissionsRoute: typeof AppClientsClientIdSoumissionsRoute
  AppClientsClientIdTachesRoute: typeof AppClientsClientIdTachesRoute
  AppClientsClientIdTempsRoute: typeof AppClientsClientIdTempsRoute
  AppClientsClientIdTermsRoute: typeof AppClientsClientIdTermsRoute
  AppClientsClientIdIndexRoute: typeof AppClientsClientIdIndexRoute
  AppClientsClientIdRendezVousNouvelleRoute: typeof AppClientsClientIdRendezVousNouvelleRoute
}

const AppClientsClientIdRouteChildren: AppClientsClientIdRouteChildren = {
  AppClientsClientIdAffairesRoute: AppClientsClientIdAffairesRoute,
  AppClientsClientIdContactsRoute: AppClientsClientIdContactsRoute,
  AppClientsClientIdDocumentsRoute: AppClientsClientIdDocumentsRoute,
  AppClientsClientIdEchangesRoute: AppClientsClientIdEchangesRoute,
  AppClientsClientIdFacturationRoute: AppClientsClientIdFacturationRoute,
  AppClientsClientIdFormationsRoute: AppClientsClientIdFormationsRoute,
  AppClientsClientIdJournalRoute: AppClientsClientIdJournalRoute,
  AppClientsClientIdNotesRoute: AppClientsClientIdNotesRoute,
  AppClientsClientIdProjetsRoute: AppClientsClientIdProjetsRoute,
  AppClientsClientIdQuestionnairesRoute: AppClientsClientIdQuestionnairesRoute,
  AppClientsClientIdRelancesRoute: AppClientsClientIdRelancesRoute,
  AppClientsClientIdRendezVousRoute: AppClientsClientIdRendezVousRoute,
  AppClientsClientIdSecretsRoute: AppClientsClientIdSecretsRoute,
  AppClientsClientIdSoumissionsRoute: AppClientsClientIdSoumissionsRoute,
  AppClientsClientIdTachesRoute: AppClientsClientIdTachesRoute,
  AppClientsClientIdTempsRoute: AppClientsClientIdTempsRoute,
  AppClientsClientIdTermsRoute: AppClientsClientIdTermsRoute,
  AppClientsClientIdIndexRoute: AppClientsClientIdIndexRoute,
  AppClientsClientIdRendezVousNouvelleRoute:
    AppClientsClientIdRendezVousNouvelleRoute,
}

const AppClientsClientIdRouteWithChildren =
  AppClientsClientIdRoute._addFileChildren(AppClientsClientIdRouteChildren)

interface AppRouteChildren {
  AppAuditRoute: typeof AppAuditRoute
  AppCorporateRoute: typeof AppCorporateRouteWithChildren
  AppDesignRoute: typeof AppDesignRoute
  AppEchangesRoute: typeof AppEchangesRouteWithChildren
  AppMaRecetteRoute: typeof AppMaRecetteRoute
  AppMemoireRoute: typeof AppMemoireRoute
  AppRelancesRoute: typeof AppRelancesRoute
  AppSettingsRoute: typeof AppSettingsRouteWithChildren
  AppTasksRoute: typeof AppTasksRouteWithChildren
  AppTeamRoute: typeof AppTeamRoute
  AppTimeRoute: typeof AppTimeRoute
  AppIndexRoute: typeof AppIndexRoute
  AppClientsClientIdRoute: typeof AppClientsClientIdRouteWithChildren
  AppFormationsShortIdRoute: typeof AppFormationsShortIdRoute
  AppFraisExpenseNumberRoute: typeof AppFraisExpenseNumberRoute
  AppMeetingPollsShortIdRoute: typeof AppMeetingPollsShortIdRoute
  AppOpportunitiesOpportunityIdRoute: typeof AppOpportunitiesOpportunityIdRoute
  AppProjectsProjectRefRoute: typeof AppProjectsProjectRefRoute
  AppQaRunIdRoute: typeof AppQaRunIdRoute
  AppQuestionnairesShortIdRoute: typeof AppQuestionnairesShortIdRoute
  AppQuotesQuoteNumberRoute: typeof AppQuotesQuoteNumberRoute
  AppValidationsShortIdRoute: typeof AppValidationsShortIdRoute
  AppClientsIndexRoute: typeof AppClientsIndexRoute
  AppFormationsIndexRoute: typeof AppFormationsIndexRoute
  AppFraisIndexRoute: typeof AppFraisIndexRoute
  AppOpportunitiesIndexRoute: typeof AppOpportunitiesIndexRoute
  AppProjectsIndexRoute: typeof AppProjectsIndexRoute
  AppProspectingIndexRoute: typeof AppProspectingIndexRoute
  AppQaIndexRoute: typeof AppQaIndexRoute
  AppQuestionnairesIndexRoute: typeof AppQuestionnairesIndexRoute
  AppQuotesIndexRoute: typeof AppQuotesIndexRoute
  AppProjectsProjectRefCahierRoute: typeof AppProjectsProjectRefCahierRoute
  AppProjectsProjectRefLivrablesRoute: typeof AppProjectsProjectRefLivrablesRoute
  AppProjectsProjectRefRecettesRoute: typeof AppProjectsProjectRefRecettesRoute
  AppProspectingProgramsProgramIdRoute: typeof AppProspectingProgramsProgramIdRoute
  AppProspectingProspectsProspectIdRoute: typeof AppProspectingProspectsProspectIdRoute
  AppQaRunIdJouerRoute: typeof AppQaRunIdJouerRoute
  AppQaBugsBugRefRoute: typeof AppQaBugsBugRefRoute
  AppQaBugsNouveauRoute: typeof AppQaBugsNouveauRoute
  AppQaBugsIndexRoute: typeof AppQaBugsIndexRoute
  AppClientsClientIdDocumentsDocumentIdRoute: typeof AppClientsClientIdDocumentsDocumentIdRoute
  AppClientsClientIdDocumentsNewRoute: typeof AppClientsClientIdDocumentsNewRoute
  AppClientsClientIdEchangesInteractionIdRoute: typeof AppClientsClientIdEchangesInteractionIdRoute
  AppProjectsProjectRefCahierKeyRoute: typeof AppProjectsProjectRefCahierKeyRoute
  AppProjectsProjectRefControlesKeyRoute: typeof AppProjectsProjectRefControlesKeyRoute
  AppProjectsProjectRefLivrablesKeyRoute: typeof AppProjectsProjectRefLivrablesKeyRoute
  AppProjectsProjectRefRecettesKeyRoute: typeof AppProjectsProjectRefRecettesKeyRoute
  AppProjectsProjectRefSprintsSprintIdRoute: typeof AppProjectsProjectRefSprintsSprintIdRoute
  AppProjectsProjectRefLivrablesKeyRecetteRoute: typeof AppProjectsProjectRefLivrablesKeyRecetteRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAuditRoute: AppAuditRoute,
  AppCorporateRoute: AppCorporateRouteWithChildren,
  AppDesignRoute: AppDesignRoute,
  AppEchangesRoute: AppEchangesRouteWithChildren,
  AppMaRecetteRoute: AppMaRecetteRoute,
  AppMemoireRoute: AppMemoireRoute,
  AppRelancesRoute: AppRelancesRoute,
  AppSettingsRoute: AppSettingsRouteWithChildren,
  AppTasksRoute: AppTasksRouteWithChildren,
  AppTeamRoute: AppTeamRoute,
  AppTimeRoute: AppTimeRoute,
  AppIndexRoute: AppIndexRoute,
  AppClientsClientIdRoute: AppClientsClientIdRouteWithChildren,
  AppFormationsShortIdRoute: AppFormationsShortIdRoute,
  AppFraisExpenseNumberRoute: AppFraisExpenseNumberRoute,
  AppMeetingPollsShortIdRoute: AppMeetingPollsShortIdRoute,
  AppOpportunitiesOpportunityIdRoute: AppOpportunitiesOpportunityIdRoute,
  AppProjectsProjectRefRoute: AppProjectsProjectRefRoute,
  AppQaRunIdRoute: AppQaRunIdRoute,
  AppQuestionnairesShortIdRoute: AppQuestionnairesShortIdRoute,
  AppQuotesQuoteNumberRoute: AppQuotesQuoteNumberRoute,
  AppValidationsShortIdRoute: AppValidationsShortIdRoute,
  AppClientsIndexRoute: AppClientsIndexRoute,
  AppFormationsIndexRoute: AppFormationsIndexRoute,
  AppFraisIndexRoute: AppFraisIndexRoute,
  AppOpportunitiesIndexRoute: AppOpportunitiesIndexRoute,
  AppProjectsIndexRoute: AppProjectsIndexRoute,
  AppProspectingIndexRoute: AppProspectingIndexRoute,
  AppQaIndexRoute: AppQaIndexRoute,
  AppQuestionnairesIndexRoute: AppQuestionnairesIndexRoute,
  AppQuotesIndexRoute: AppQuotesIndexRoute,
  AppProjectsProjectRefCahierRoute: AppProjectsProjectRefCahierRoute,
  AppProjectsProjectRefLivrablesRoute: AppProjectsProjectRefLivrablesRoute,
  AppProjectsProjectRefRecettesRoute: AppProjectsProjectRefRecettesRoute,
  AppProspectingProgramsProgramIdRoute: AppProspectingProgramsProgramIdRoute,
  AppProspectingProspectsProspectIdRoute:
    AppProspectingProspectsProspectIdRoute,
  AppQaRunIdJouerRoute: AppQaRunIdJouerRoute,
  AppQaBugsBugRefRoute: AppQaBugsBugRefRoute,
  AppQaBugsNouveauRoute: AppQaBugsNouveauRoute,
  AppQaBugsIndexRoute: AppQaBugsIndexRoute,
  AppClientsClientIdDocumentsDocumentIdRoute:
    AppClientsClientIdDocumentsDocumentIdRoute,
  AppClientsClientIdDocumentsNewRoute: AppClientsClientIdDocumentsNewRoute,
  AppClientsClientIdEchangesInteractionIdRoute:
    AppClientsClientIdEchangesInteractionIdRoute,
  AppProjectsProjectRefCahierKeyRoute: AppProjectsProjectRefCahierKeyRoute,
  AppProjectsProjectRefControlesKeyRoute:
    AppProjectsProjectRefControlesKeyRoute,
  AppProjectsProjectRefLivrablesKeyRoute:
    AppProjectsProjectRefLivrablesKeyRoute,
  AppProjectsProjectRefRecettesKeyRoute: AppProjectsProjectRefRecettesKeyRoute,
  AppProjectsProjectRefSprintsSprintIdRoute:
    AppProjectsProjectRefSprintsSprintIdRoute,
  AppProjectsProjectRefLivrablesKeyRecetteRoute:
    AppProjectsProjectRefLivrablesKeyRecetteRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface PortalCompteRouteChildren {
  PortalCompteNotificationsRoute: typeof PortalCompteNotificationsRoute
  PortalCompteIndexRoute: typeof PortalCompteIndexRoute
}

const PortalCompteRouteChildren: PortalCompteRouteChildren = {
  PortalCompteNotificationsRoute: PortalCompteNotificationsRoute,
  PortalCompteIndexRoute: PortalCompteIndexRoute,
}

const PortalCompteRouteWithChildren = PortalCompteRoute._addFileChildren(
  PortalCompteRouteChildren,
)

interface PortalRouteChildren {
  PortalAccesRoute: typeof PortalAccesRoute
  PortalCompteRoute: typeof PortalCompteRouteWithChildren
  PortalDocumentsRoute: typeof PortalDocumentsRoute
  PortalNotificationsRoute: typeof PortalNotificationsRoute
  PortalReserverRoute: typeof PortalReserverRoute
  PortalTimeRoute: typeof PortalTimeRoute
  PortalValidationsRoute: typeof PortalValidationsRoute
  PortalIndexRoute: typeof PortalIndexRoute
  PortalDocumentsNouveauRoute: typeof PortalDocumentsNouveauRoute
  PortalFormationsVideoIdRoute: typeof PortalFormationsVideoIdRoute
  PortalLivrablesDeliverableIdRoute: typeof PortalLivrablesDeliverableIdRoute
  PortalProjetsProjectIdRoute: typeof PortalProjetsProjectIdRoute
  PortalQuestionnairesQuestionnaireIdRoute: typeof PortalQuestionnairesQuestionnaireIdRoute
  PortalRendezVousPollIdRoute: typeof PortalRendezVousPollIdRoute
  PortalRequestsNewRoute: typeof PortalRequestsNewRoute
  PortalReservationsBookingIdRoute: typeof PortalReservationsBookingIdRoute
  PortalSectionsSectionIdRoute: typeof PortalSectionsSectionIdRoute
  PortalSoumissionsQuoteIdRoute: typeof PortalSoumissionsQuoteIdRoute
  PortalTasksTaskKeyRoute: typeof PortalTasksTaskKeyRoute
  PortalFormationsIndexRoute: typeof PortalFormationsIndexRoute
  PortalProjetsIndexRoute: typeof PortalProjetsIndexRoute
  PortalQuestionnairesIndexRoute: typeof PortalQuestionnairesIndexRoute
  PortalRendezVousIndexRoute: typeof PortalRendezVousIndexRoute
  PortalSoumissionsIndexRoute: typeof PortalSoumissionsIndexRoute
  PortalTasksIndexRoute: typeof PortalTasksIndexRoute
  PortalProjetsProjectIdCahierKeyRoute: typeof PortalProjetsProjectIdCahierKeyRoute
  PortalProjetsProjectIdLivrablesKeyRoute: typeof PortalProjetsProjectIdLivrablesKeyRoute
  PortalProjetsProjectIdCahierIndexRoute: typeof PortalProjetsProjectIdCahierIndexRoute
  PortalProjetsProjectIdLivrablesKeyTesterRoute: typeof PortalProjetsProjectIdLivrablesKeyTesterRoute
}

const PortalRouteChildren: PortalRouteChildren = {
  PortalAccesRoute: PortalAccesRoute,
  PortalCompteRoute: PortalCompteRouteWithChildren,
  PortalDocumentsRoute: PortalDocumentsRoute,
  PortalNotificationsRoute: PortalNotificationsRoute,
  PortalReserverRoute: PortalReserverRoute,
  PortalTimeRoute: PortalTimeRoute,
  PortalValidationsRoute: PortalValidationsRoute,
  PortalIndexRoute: PortalIndexRoute,
  PortalDocumentsNouveauRoute: PortalDocumentsNouveauRoute,
  PortalFormationsVideoIdRoute: PortalFormationsVideoIdRoute,
  PortalLivrablesDeliverableIdRoute: PortalLivrablesDeliverableIdRoute,
  PortalProjetsProjectIdRoute: PortalProjetsProjectIdRoute,
  PortalQuestionnairesQuestionnaireIdRoute:
    PortalQuestionnairesQuestionnaireIdRoute,
  PortalRendezVousPollIdRoute: PortalRendezVousPollIdRoute,
  PortalRequestsNewRoute: PortalRequestsNewRoute,
  PortalReservationsBookingIdRoute: PortalReservationsBookingIdRoute,
  PortalSectionsSectionIdRoute: PortalSectionsSectionIdRoute,
  PortalSoumissionsQuoteIdRoute: PortalSoumissionsQuoteIdRoute,
  PortalTasksTaskKeyRoute: PortalTasksTaskKeyRoute,
  PortalFormationsIndexRoute: PortalFormationsIndexRoute,
  PortalProjetsIndexRoute: PortalProjetsIndexRoute,
  PortalQuestionnairesIndexRoute: PortalQuestionnairesIndexRoute,
  PortalRendezVousIndexRoute: PortalRendezVousIndexRoute,
  PortalSoumissionsIndexRoute: PortalSoumissionsIndexRoute,
  PortalTasksIndexRoute: PortalTasksIndexRoute,
  PortalProjetsProjectIdCahierKeyRoute: PortalProjetsProjectIdCahierKeyRoute,
  PortalProjetsProjectIdLivrablesKeyRoute:
    PortalProjetsProjectIdLivrablesKeyRoute,
  PortalProjetsProjectIdCahierIndexRoute:
    PortalProjetsProjectIdCahierIndexRoute,
  PortalProjetsProjectIdLivrablesKeyTesterRoute:
    PortalProjetsProjectIdLivrablesKeyTesterRoute,
}

const PortalRouteWithChildren =
  PortalRoute._addFileChildren(PortalRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  PortalRoute: PortalRouteWithChildren,
  ConnexionLienRoute: ConnexionLienRoute,
  InvitationTokenRoute: InvitationTokenRoute,
  PSlugRoute: PSlugRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
